var _rect, _defs, _g, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _polyline, _line27, _line28, _line29, _line30, _polyline2, _line31, _line32, _line33, _polyline3, _line34, _line35, _line36, _line37, _polyline4, _line38, _polyline5, _line39, _line40, _polyline6, _line41, _line42, _line43, _polyline7, _line44, _line45, _line46, _polyline8, _line47, _polyline9, _line48, _polyline10, _line49, _line50, _line51, _line52, _polyline11, _line53, _line54, _line55, _polyline12, _line56, _line57, _polyline13, _line58, _polyline14, _line59, _line60, _line61, _line62, _polyline15, _line63, _line64, _line65, _line66, _line67, _line68, _polyline16, _line69, _line70, _line71, _polyline17, _line72, _line73, _polyline18, _line74, _line75, _line76, _line77, _line78, _line79, _line80, _line81, _line82, _polyline19, _line83, _line84, _line85, _line86, _polyline20, _line87, _line88, _line89, _line90, _polyline21, _line91, _line92, _line93, _line94, _line95, _line96, _line97, _line98, _line99, _polyline22, _line100, _line101, _line102, _line103, _polyline23, _line104, _line105, _line106, _line107, _line108, _line109, _line110, _line111, _polyline24, _line112, _line113, _polyline25, _line114, _polyline26, _line115, _line116, _line117, _line118, _line119, _line120, _line121, _line122, _line123, _line124, _line125, _line126, _polyline27, _line127, _polyline28, _line128, _polyline29, _line129, _line130, _line131, _line132, _line133, _line134, _line135, _line136, _line137, _line138, _line139, _line140, _line141, _line142, _line143, _line144, _line145, _line146, _line147, _line148, _line149, _line150, _line151, _line152, _line153, _line154, _line155, _line156, _line157, _line158, _line159, _line160, _line161, _line162, _line163, _line164, _line165, _line166, _line167, _line168, _line169, _line170, _line171, _line172, _line173, _line174, _line175, _line176, _line177, _line178, _line179, _line180, _polyline30, _line181, _line182, _line183, _line184, _line185, _line186, _line187, _line188, _line189, _line190, _line191, _line192, _line193, _line194, _line195, _line196, _line197, _line198, _line199, _line200, _line201, _line202, _line203, _line204, _line205, _line206, _line207, _line208, _line209, _line210, _line211, _line212, _line213, _line214, _line215, _line216, _line217, _line218, _line219, _line220, _line221, _line222, _line223, _line224, _line225, _line226, _line227, _line228, _line229, _line230, _line231, _line232, _line233, _line234, _line235, _line236, _line237, _line238, _line239, _line240, _line241, _line242, _line243, _line244, _line245, _line246, _line247, _line248, _line249, _line250, _line251, _line252, _line253, _line254, _line255, _line256, _line257, _line258, _line259, _line260, _line261, _line262, _line263, _line264, _line265, _line266, _line267, _line268, _line269, _line270, _line271, _line272, _line273, _line274, _line275, _line276, _line277, _line278, _line279, _line280, _line281, _line282, _line283, _line284, _line285, _line286, _line287, _line288, _line289, _line290, _line291, _line292, _line293, _line294, _line295, _line296, _line297, _line298, _line299, _line300, _line301, _line302, _line303, _line304, _line305, _line306, _line307, _line308, _line309, _line310, _line311, _line312, _line313, _line314, _line315, _line316, _line317, _line318, _line319, _line320, _line321, _line322, _line323, _line324, _line325, _line326, _line327, _line328, _line329, _line330, _line331, _line332, _line333, _line334, _line335, _line336, _line337, _line338, _line339, _line340, _line341, _line342, _line343, _line344, _line345, _line346, _line347, _line348, _line349, _line350, _line351, _line352, _line353, _line354, _line355, _line356, _line357, _line358, _line359, _line360, _line361, _line362, _line363, _line364, _line365, _line366, _line367, _line368, _line369, _line370, _line371, _line372, _line373, _line374, _line375, _line376, _line377, _line378, _line379, _line380, _line381, _line382, _line383, _line384, _line385, _line386, _line387, _line388, _line389, _line390, _line391, _line392, _line393, _line394, _line395, _line396, _line397, _line398, _line399, _line400, _line401, _line402, _line403, _line404, _line405, _line406, _line407, _line408, _line409, _line410, _line411, _polyline31, _line412, _line413, _line414, _line415, _line416, _line417, _line418, _line419, _line420, _line421, _line422, _line423, _line424, _line425, _line426, _line427, _line428, _line429, _line430, _line431, _line432, _line433, _line434, _line435, _line436, _line437, _line438, _line439, _line440, _line441, _line442, _line443, _line444, _line445, _line446, _line447, _line448, _line449, _line450, _line451, _line452, _line453, _line454, _line455, _line456, _line457, _line458, _line459, _line460, _line461, _line462, _line463, _line464, _line465, _line466, _line467, _line468, _line469, _line470, _line471, _line472, _line473, _line474, _line475, _line476, _line477, _line478, _line479, _line480, _line481, _line482, _line483, _line484, _line485, _line486, _line487, _line488, _line489, _line490, _line491, _line492, _line493, _line494, _line495, _line496, _line497, _line498, _line499, _line500, _line501, _line502, _line503, _line504, _line505, _line506, _line507, _line508, _line509, _line510, _line511, _line512, _line513, _line514, _line515, _line516, _line517, _line518, _line519, _line520, _line521, _line522, _line523, _line524, _line525, _line526, _line527, _line528, _line529, _line530, _line531, _line532, _line533, _line534, _line535, _line536, _line537, _line538, _line539, _line540, _line541, _line542, _line543, _line544, _line545, _line546, _line547, _line548, _line549, _line550, _line551, _line552, _line553, _line554, _line555, _line556, _line557, _line558, _line559, _line560, _line561, _line562, _line563, _line564, _line565, _line566, _line567, _line568, _line569, _line570, _line571, _line572, _line573, _line574, _line575, _line576, _line577, _line578, _line579, _line580, _line581, _line582, _line583, _line584, _line585, _line586, _line587, _line588, _line589, _line590, _line591, _line592, _line593, _line594, _line595, _line596, _line597, _line598, _line599, _line600, _line601, _line602, _line603, _line604, _line605, _line606, _line607, _line608, _line609, _line610, _line611, _line612, _line613, _line614, _line615, _line616, _line617, _line618, _line619, _line620, _line621, _line622, _line623, _line624, _line625, _line626, _line627, _line628, _line629, _line630, _line631, _line632, _line633, _line634, _line635, _line636, _line637, _line638, _line639, _line640, _line641, _line642, _line643, _line644, _line645, _line646, _line647, _line648, _line649, _line650, _line651, _line652, _line653, _line654, _line655, _line656, _line657, _line658, _line659, _line660, _line661, _line662, _line663, _line664, _line665, _line666, _line667, _line668, _line669, _line670, _line671, _line672, _line673, _line674, _line675, _polygon, _line676, _line677, _line678, _line679, _line680, _line681, _line682, _line683, _line684, _line685, _line686, _line687, _line688, _line689, _line690, _line691, _line692, _line693, _line694, _line695, _line696, _line697, _line698, _line699, _line700, _line701, _line702, _line703, _line704, _line705, _line706, _line707, _line708, _line709, _line710, _line711, _line712, _line713, _line714, _line715, _line716, _line717, _line718, _line719, _line720, _line721, _line722, _line723, _line724, _line725, _line726, _line727, _line728, _line729, _line730, _line731, _line732, _line733, _line734, _line735, _line736, _line737, _line738;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNamiMapsGl01Tl04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1224 792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        fill: none;\n      }\n\n      .cls-3 {\n        stroke-linecap: square;\n      }\n\n      .cls-3, .cls-4 {\n        stroke: #000;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -922.21,
    y: 891.85,
    width: 1149.36,
    height: 630.12
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1150.87,
    y1: 512.55,
    x2: 1151.39,
    y2: 512.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1150.87,
    y1: 516.58,
    x2: 1151.39,
    y2: 516.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 989.37,
    y1: 512.55,
    x2: 989.88,
    y2: 512.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 985.46,
    y1: 512.55,
    x2: 985.77,
    y2: 512.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 989.37,
    y1: 516.58,
    x2: 989.88,
    y2: 516.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 985.46,
    y1: 516.58,
    x2: 985.77,
    y2: 516.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 824.06,
    y1: 512.55,
    x2: 824.26,
    y2: 512.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 824.06,
    y1: 516.58,
    x2: 824.26,
    y2: 516.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 662.56,
    y1: 512.55,
    x2: 663.07,
    y2: 512.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 662.56,
    y1: 516.58,
    x2: 663.07,
    y2: 516.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 662.56,
    y1: 290.46,
    x2: 663.07,
    y2: 290.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 824.06,
    y1: 290.46,
    x2: 824.26,
    y2: 290.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 989.37,
    y1: 290.46,
    x2: 989.88,
    y2: 290.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 985.46,
    y1: 290.46,
    x2: 985.77,
    y2: 290.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1150.87,
    y1: 290.46,
    x2: 1151.39,
    y2: 290.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1150.87,
    y1: 512.55,
    x2: 1146.75,
    y2: 512.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1150.87,
    y1: 516.58,
    x2: 1150.87,
    y2: 512.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1150.87,
    y1: 512.34,
    x2: 1146.75,
    y2: 512.34
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "1151.39 512.55 1151.39 512.34 1150.87 512.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1151.39,
    y1: 516.58,
    x2: 1151.39,
    y2: 512.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1146.45,
    y1: 512.55,
    x2: 1146.45,
    y2: 516.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1146.75,
    y1: 512.55,
    x2: 1146.45,
    y2: 512.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1146.45,
    y1: 512.55,
    x2: 1146.45,
    y2: 516.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "1146.75 512.34 1146.45 512.34 1146.45 512.55"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1146.75,
    y1: 516.58,
    x2: 1150.87,
    y2: 516.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "1150.87 516.88 1151.39 516.88 1151.39 516.58"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1146.75,
    y1: 516.88,
    x2: 1150.87,
    y2: 516.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1146.45,
    y1: 516.58,
    x2: 1146.75,
    y2: 516.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "1146.45 516.58 1146.45 516.88 1146.75 516.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 989.37,
    y1: 512.55,
    x2: 985.46,
    y2: 512.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 989.37,
    y1: 516.58,
    x2: 989.37,
    y2: 512.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 989.37,
    y1: 512.34,
    x2: 985.46,
    y2: 512.34
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "989.88 512.55 989.88 512.34 989.37 512.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 989.88,
    y1: 516.58,
    x2: 989.88,
    y2: 512.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 985.46,
    y1: 512.55,
    x2: 985.46,
    y2: 516.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 984.94,
    y1: 512.55,
    x2: 984.94,
    y2: 516.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "985.46 512.34 984.94 512.34 984.94 512.55"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 985.46,
    y1: 516.58,
    x2: 989.37,
    y2: 516.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "989.37 516.88 989.88 516.88 989.88 516.58"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 985.46,
    y1: 516.88,
    x2: 989.37,
    y2: 516.88
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "984.94 516.58 984.94 516.88 985.46 516.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 828.18,
    y1: 512.55,
    x2: 824.06,
    y2: 512.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 828.38,
    y1: 512.55,
    x2: 828.18,
    y2: 512.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 828.38,
    y1: 516.58,
    x2: 828.38,
    y2: 512.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 828.18,
    y1: 512.34,
    x2: 824.06,
    y2: 512.34
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "828.38 512.55 828.38 512.34 828.18 512.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 828.38,
    y1: 516.58,
    x2: 828.38,
    y2: 512.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 824.06,
    y1: 512.55,
    x2: 824.06,
    y2: 516.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 823.54,
    y1: 512.55,
    x2: 823.54,
    y2: 516.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "824.06 512.34 823.54 512.34 823.54 512.55"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 828.18,
    y1: 516.58,
    x2: 828.38,
    y2: 516.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 824.06,
    y1: 516.58,
    x2: 828.18,
    y2: 516.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "828.18 516.88 828.38 516.88 828.38 516.58"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 824.06,
    y1: 516.88,
    x2: 828.18,
    y2: 516.88
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "823.54 516.58 823.54 516.88 824.06 516.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 666.67,
    y1: 512.55,
    x2: 662.56,
    y2: 512.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 666.88,
    y1: 512.55,
    x2: 666.67,
    y2: 512.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 666.88,
    y1: 516.58,
    x2: 666.88,
    y2: 512.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 666.67,
    y1: 512.34,
    x2: 662.56,
    y2: 512.34
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "666.88 512.55 666.88 512.34 666.67 512.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 666.88,
    y1: 516.58,
    x2: 666.88,
    y2: 512.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 662.56,
    y1: 512.55,
    x2: 662.56,
    y2: 516.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 662.25,
    y1: 512.55,
    x2: 662.25,
    y2: 516.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 662.56,
    y1: 512.34,
    x2: 662.25,
    y2: 512.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 666.67,
    y1: 516.58,
    x2: 666.88,
    y2: 516.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 662.56,
    y1: 516.58,
    x2: 666.67,
    y2: 516.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "666.67 516.88 666.88 516.88 666.88 516.58"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 662.56,
    y1: 516.88,
    x2: 666.67,
    y2: 516.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 662.25,
    y1: 516.58,
    x2: 662.56,
    y2: 516.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 666.67,
    y1: 285.92,
    x2: 662.56,
    y2: 285.92
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "666.88 286.42 666.88 285.92 666.67 285.92"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 666.88,
    y1: 290.46,
    x2: 666.88,
    y2: 286.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 666.67,
    y1: 285.92,
    x2: 662.56,
    y2: 285.92
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "666.88 286.42 666.88 285.92 666.67 285.92"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 666.88,
    y1: 290.46,
    x2: 666.88,
    y2: 286.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 662.56,
    y1: 286.42,
    x2: 662.56,
    y2: 290.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 662.56,
    y1: 285.92,
    x2: 662.56,
    y2: 286.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 662.25,
    y1: 286.42,
    x2: 662.25,
    y2: 290.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 662.56,
    y1: 285.92,
    x2: 662.25,
    y2: 286.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 666.67,
    y1: 290.46,
    x2: 666.88,
    y2: 290.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 662.56,
    y1: 290.46,
    x2: 666.67,
    y2: 290.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 666.67,
    y1: 290.76,
    x2: 666.88,
    y2: 290.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 662.56,
    y1: 290.76,
    x2: 666.67,
    y2: 290.76
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "662.25 290.46 662.56 290.46 662.56 290.76"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 828.18,
    y1: 285.92,
    x2: 824.06,
    y2: 285.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 828.38,
    y1: 286.42,
    x2: 828.18,
    y2: 285.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 828.38,
    y1: 290.46,
    x2: 828.38,
    y2: 286.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 828.18,
    y1: 285.92,
    x2: 824.06,
    y2: 285.92
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "828.38 286.42 828.38 285.92 828.18 285.92"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 828.38,
    y1: 290.46,
    x2: 828.38,
    y2: 286.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 824.06,
    y1: 286.42,
    x2: 824.06,
    y2: 290.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 824.06,
    y1: 285.92,
    x2: 824.06,
    y2: 286.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 823.54,
    y1: 286.42,
    x2: 823.54,
    y2: 290.46
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "824.06 285.92 823.54 285.92 823.54 286.42"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 828.18,
    y1: 290.46,
    x2: 828.38,
    y2: 290.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 824.06,
    y1: 290.46,
    x2: 828.18,
    y2: 290.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 828.18,
    y1: 290.76,
    x2: 828.38,
    y2: 290.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 824.06,
    y1: 290.76,
    x2: 828.18,
    y2: 290.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 823.54,
    y1: 290.46,
    x2: 824.06,
    y2: 290.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 989.37,
    y1: 285.92,
    x2: 985.46,
    y2: 285.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 989.37,
    y1: 286.42,
    x2: 989.37,
    y2: 285.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 989.37,
    y1: 290.46,
    x2: 989.37,
    y2: 286.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 989.37,
    y1: 285.92,
    x2: 985.46,
    y2: 285.92
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "989.88 286.42 989.88 285.92 989.37 285.92"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 989.88,
    y1: 290.46,
    x2: 989.88,
    y2: 286.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 985.46,
    y1: 286.42,
    x2: 985.46,
    y2: 290.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 985.46,
    y1: 285.92,
    x2: 985.46,
    y2: 286.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 984.94,
    y1: 286.42,
    x2: 984.94,
    y2: 290.46
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "985.46 285.92 984.94 285.92 984.94 286.42"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 985.46,
    y1: 290.46,
    x2: 989.37,
    y2: 290.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 989.37,
    y1: 290.76,
    x2: 989.88,
    y2: 290.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 985.46,
    y1: 290.76,
    x2: 989.37,
    y2: 290.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 984.94,
    y1: 290.46,
    x2: 985.46,
    y2: 290.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1150.87,
    y1: 285.92,
    x2: 1146.75,
    y2: 285.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1150.87,
    y1: 286.42,
    x2: 1150.87,
    y2: 285.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1150.87,
    y1: 290.46,
    x2: 1150.87,
    y2: 286.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1150.87,
    y1: 285.92,
    x2: 1146.75,
    y2: 285.92
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "1151.39 286.42 1151.39 285.92 1150.87 285.92"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1151.39,
    y1: 290.46,
    x2: 1151.39,
    y2: 286.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1146.45,
    y1: 286.42,
    x2: 1146.45,
    y2: 290.46
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "1146.75 285.92 1146.45 285.92 1146.45 286.42"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1146.45,
    y1: 286.42,
    x2: 1146.45,
    y2: 290.46
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "1146.75 285.92 1146.45 285.92 1146.45 286.42"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1146.75,
    y1: 290.46,
    x2: 1150.87,
    y2: 290.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1150.87,
    y1: 290.76,
    x2: 1151.39,
    y2: 290.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1146.75,
    y1: 290.76,
    x2: 1150.87,
    y2: 290.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1146.45,
    y1: 290.46,
    x2: 1146.75,
    y2: 290.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1146.45,
    y1: 290.46,
    x2: 1146.75,
    y2: 290.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 597.71,
    y1: 505.78,
    x2: 597.71,
    y2: 213.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1397.71,
    y1: 524.15,
    x2: 617.06,
    y2: 524.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 607.79,
    y1: 203.79,
    x2: 597.71,
    y2: 213.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1378.36,
    y1: 203.79,
    x2: 607.79,
    y2: 203.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 617.06,
    y1: 524.15,
    x2: 597.71,
    y2: 505.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 631.47,
    y1: 517.59,
    x2: 631.47,
    y2: 470.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 631.47,
    y1: 470.37,
    x2: 608.52,
    y2: 470.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 608.52,
    y1: 470.37,
    x2: 608.52,
    y2: 517.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 608.52,
    y1: 517.59,
    x2: 631.47,
    y2: 517.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 608.52,
    y1: 517.59,
    x2: 631.47,
    y2: 470.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 608.52,
    y1: 470.37,
    x2: 631.47,
    y2: 517.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 631.47,
    y1: 470.37,
    x2: 631.47,
    y2: 423.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 631.47,
    y1: 423.15,
    x2: 608.52,
    y2: 423.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 608.52,
    y1: 423.15,
    x2: 608.52,
    y2: 470.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 608.52,
    y1: 470.37,
    x2: 631.47,
    y2: 470.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 608.52,
    y1: 470.37,
    x2: 631.47,
    y2: 423.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 608.52,
    y1: 423.15,
    x2: 631.47,
    y2: 470.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 631.47,
    y1: 423.15,
    x2: 631.47,
    y2: 375.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 631.47,
    y1: 375.92,
    x2: 608.52,
    y2: 375.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 608.52,
    y1: 375.92,
    x2: 608.52,
    y2: 423.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 608.52,
    y1: 423.15,
    x2: 631.47,
    y2: 423.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 608.52,
    y1: 423.15,
    x2: 631.47,
    y2: 375.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 608.52,
    y1: 375.92,
    x2: 631.47,
    y2: 423.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 641.66,
    y1: 508.51,
    x2: 664.82,
    y2: 508.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 664.82,
    y1: 508.51,
    x2: 664.82,
    y2: 367.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 664.82,
    y1: 367.55,
    x2: 641.66,
    y2: 367.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 641.66,
    y1: 367.55,
    x2: 641.66,
    y2: 508.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 641.66,
    y1: 438.08,
    x2: 664.82,
    y2: 438.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 641.66,
    y1: 438.08,
    x2: 664.82,
    y2: 508.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 664.82,
    y1: 438.08,
    x2: 641.66,
    y2: 508.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 641.66,
    y1: 367.55,
    x2: 664.82,
    y2: 438.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 664.82,
    y1: 367.55,
    x2: 641.66,
    y2: 438.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1207.9,
    y1: 491.36,
    x2: 1195.34,
    y2: 491.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1207.9,
    y1: 499.23,
    x2: 1207.9,
    y2: 491.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1208.21,
    y1: 477.23,
    x2: 1208.21,
    y2: 499.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1189.16,
    y1: 475.92,
    x2: 1178.05,
    y2: 475.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1195.34,
    y1: 491.36,
    x2: 1207.9,
    y2: 491.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1195.34,
    y1: 477.94,
    x2: 1207.9,
    y2: 477.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1178.05,
    y1: 492.06,
    x2: 1195.34,
    y2: 492.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1178.05,
    y1: 492.06,
    x2: 1178.05,
    y2: 475.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1195.34,
    y1: 492.06,
    x2: 1195.34,
    y2: 475.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1178.05,
    y1: 475.92,
    x2: 1195.34,
    y2: 475.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1208.21,
    y1: 477.23,
    x2: 1232.6,
    y2: 477.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1208.21,
    y1: 499.23,
    x2: 1232.6,
    y2: 499.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1208.21,
    y1: 499.23,
    x2: 1258.85,
    y2: 499.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1208.21,
    y1: 477.23,
    x2: 1259.57,
    y2: 477.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1204.6,
    y1: 453.22,
    x2: 1204.6,
    y2: 445.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1204.6,
    y1: 453.22,
    x2: 1232.81,
    y2: 453.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1204.6,
    y1: 445.85,
    x2: 1232.81,
    y2: 445.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1205.32,
    y1: 250.81,
    x2: 1195.85,
    y2: 250.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1181.44,
    y1: 250.81,
    x2: 1174.96,
    y2: 250.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1205.32,
    y1: 247.07,
    x2: 1195.85,
    y2: 247.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1186.8,
    y1: 256.15,
    x2: 1187.31,
    y2: 256.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1174.96,
    y1: 250.81,
    x2: 1175.47,
    y2: 250.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1181.44,
    y1: 247.07,
    x2: 1174.96,
    y2: 247.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1181.44,
    y1: 247.07,
    x2: 1181.44,
    y2: 250.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1174.96,
    y1: 247.07,
    x2: 1174.96,
    y2: 250.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1195.85,
    y1: 236.88,
    x2: 1181.44,
    y2: 236.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1186.8,
    y1: 256.36,
    x2: 1185.05,
    y2: 256.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1185.05,
    y1: 253.33,
    x2: 1185.05,
    y2: 256.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1181.44,
    y1: 253.33,
    x2: 1181.44,
    y2: 236.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1195.85,
    y1: 253.33,
    x2: 1195.85,
    y2: 236.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1186.8,
    y1: 257.67,
    x2: 1186.8,
    y2: 256.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1195.85,
    y1: 253.33,
    x2: 1181.44,
    y2: 253.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1189.37,
    y1: 257.67,
    x2: 1189.88,
    y2: 257.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1186.8,
    y1: 257.67,
    x2: 1189.37,
    y2: 257.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1189.37,
    y1: 257.67,
    x2: 1195.85,
    y2: 257.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1195.85,
    y1: 253.33,
    x2: 1195.85,
    y2: 257.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1180.62,
    y1: 251.82,
    x2: 1180.62,
    y2: 255.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1180.62,
    y1: 255.14,
    x2: 1172.9,
    y2: 255.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1180.62,
    y1: 251.82,
    x2: 1172.9,
    y2: 251.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1172.9,
    y1: 251.82,
    x2: 1172.9,
    y2: 255.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1206.15,
    y1: 245.26,
    x2: 1206.15,
    y2: 255.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1235.69,
    y1: 245.26,
    x2: 1206.15,
    y2: 245.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1227.45,
    y1: 255.35,
    x2: 1206.15,
    y2: 255.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1216.96,
    y1: 244.25,
    x2: 1216.96,
    y2: 253.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1216.96,
    y1: 253.63,
    x2: 1226.94,
    y2: 253.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1216.96,
    y1: 244.25,
    x2: 1226.94,
    y2: 244.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1205.32,
    y1: 247.07,
    x2: 1205.32,
    y2: 250.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1196.88,
    y1: 250.81,
    x2: 1196.88,
    y2: 263.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1196.88,
    y1: 263.42,
    x2: 1202.24,
    y2: 263.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1202.03,
    y1: 250.81,
    x2: 1202.03,
    y2: 263.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1003.78,
    y1: 353.42,
    x2: 881.39,
    y2: 353.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1003.78,
    y1: 325.88,
    x2: 881.39,
    y2: 325.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 881.39,
    y1: 353.42,
    x2: 881.39,
    y2: 325.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 881.39,
    y1: 350.6,
    x2: 857.41,
    y2: 350.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 881.39,
    y1: 328.4,
    x2: 857.41,
    y2: 328.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 885.51,
    y1: 347.07,
    x2: 885.51,
    y2: 332.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1003.78,
    y1: 325.88,
    x2: 1003.78,
    y2: 353.42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1033.53,
    y1: 350.6,
    x2: 1025.91,
    y2: 350.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1033.53,
    y1: 328.4,
    x2: 1025.91,
    y2: 328.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1033.53,
    y1: 350.6,
    x2: 1033.53,
    y2: 328.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1018.4,
    y1: 325.37,
    x2: 1018.4,
    y2: 327.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1014.79,
    y1: 325.37,
    x2: 1014.79,
    y2: 327.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1025.91,
    y1: 327.59,
    x2: 1004.29,
    y2: 327.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1025.91,
    y1: 351.61,
    x2: 1004.29,
    y2: 351.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1025.91,
    y1: 351.61,
    x2: 1025.91,
    y2: 327.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1004.29,
    y1: 351.61,
    x2: 1004.29,
    y2: 327.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 864.1,
    y1: 378.14,
    x2: 864.1,
    y2: 383.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 853.08,
    y1: 383.69,
    x2: 872.13,
    y2: 383.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 884.99,
    y1: 378.14,
    x2: 864.1,
    y2: 378.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 853.08,
    y1: 422.14,
    x2: 872.13,
    y2: 422.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 870.28,
    y1: 320.02,
    x2: 868.01,
    y2: 320.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 875.42,
    y1: 315.28,
    x2: 868.01,
    y2: 315.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 857.41,
    y1: 350.6,
    x2: 857.41,
    y2: 328.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 868.01,
    y1: 321.03,
    x2: 881.39,
    y2: 321.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 881.39,
    y1: 328.4,
    x2: 881.39,
    y2: 321.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 868.01,
    y1: 323.35,
    x2: 868.01,
    y2: 328.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 868.01,
    y1: 328.4,
    x2: 868.01,
    y2: 321.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 870.28,
    y1: 350.6,
    x2: 870.28,
    y2: 355.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 872.85,
    y1: 350.6,
    x2: 872.85,
    y2: 355.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 853.08,
    y1: 355.64,
    x2: 877.27,
    y2: 355.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 853.08,
    y1: 377.64,
    x2: 853.08,
    y2: 355.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 853.08,
    y1: 377.64,
    x2: 877.27,
    y2: 377.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 877.27,
    y1: 355.64,
    x2: 877.27,
    y2: 377.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 872.85,
    y1: 320.02,
    x2: 872.85,
    y2: 321.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 870.28,
    y1: 320.02,
    x2: 870.28,
    y2: 321.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 868.01,
    y1: 328.4,
    x2: 868.01,
    y2: 321.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 868.01,
    y1: 315.28,
    x2: 868.01,
    y2: 320.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 875.42,
    y1: 315.28,
    x2: 875.42,
    y2: 320.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 875.42,
    y1: 320.02,
    x2: 870.28,
    y2: 320.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 853.08,
    y1: 383.69,
    x2: 853.08,
    y2: 422.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 884.99,
    y1: 378.14,
    x2: 884.99,
    y2: 380.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1125.34,
    y1: 438.28,
    x2: 961.06,
    y2: 438.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1112.27,
    y1: 317.5,
    x2: 1112.27,
    y2: 380.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 885.51,
    y1: 380.67,
    x2: 885.51,
    y2: 300.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1125.34,
    y1: 438.28,
    x2: 1125.34,
    y2: 380.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1125.34,
    y1: 380.67,
    x2: 872.13,
    y2: 380.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 872.13,
    y1: 380.67,
    x2: 872.13,
    y2: 438.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1125.34,
    y1: 386.01,
    x2: 1127.71,
    y2: 386.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1127.71,
    y1: 411.24,
    x2: 1127.71,
    y2: 413.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1127.71,
    y1: 386.01,
    x2: 1127.71,
    y2: 394.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1132.86,
    y1: 394.59,
    x2: 1127.71,
    y2: 394.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1132.86,
    y1: 394.59,
    x2: 1132.86,
    y2: 411.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1132.86,
    y1: 411.24,
    x2: 1127.71,
    y2: 411.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1119.99,
    y1: 384.2,
    x2: 1126.89,
    y2: 384.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1126.89,
    y1: 379.46,
    x2: 1126.89,
    y2: 384.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1119.99,
    y1: 379.46,
    x2: 1119.99,
    y2: 384.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1119.99,
    y1: 379.46,
    x2: 1126.89,
    y2: 379.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1139.55,
    y1: 423.15,
    x2: 1125.34,
    y2: 423.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1139.55,
    y1: 423.15,
    x2: 1139.55,
    y2: 413.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1125.34,
    y1: 413.06,
    x2: 1147.48,
    y2: 413.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1138.01,
    y1: 408.72,
    x2: 1147.48,
    y2: 408.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1138.01,
    y1: 408.72,
    x2: 1138.01,
    y2: 413.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1147.48,
    y1: 408.72,
    x2: 1147.48,
    y2: 416.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1147.99,
    y1: 420.62,
    x2: 1147.99,
    y2: 416.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1139.55,
    y1: 420.62,
    x2: 1147.99,
    y2: 420.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1139.55,
    y1: 416.59,
    x2: 1147.99,
    y2: 416.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1183.19,
    y1: 416.59,
    x2: 1198.43,
    y2: 416.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1183.19,
    y1: 420.62,
    x2: 1198.43,
    y2: 420.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1198.43,
    y1: 420.62,
    x2: 1198.43,
    y2: 416.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1204.09,
    y1: 427.18,
    x2: 1220.04,
    y2: 427.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1204.09,
    y1: 427.18,
    x2: 1204.09,
    y2: 410.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1220.04,
    y1: 410.53,
    x2: 1220.04,
    y2: 427.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1204.09,
    y1: 410.53,
    x2: 1220.04,
    y2: 410.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1199.46,
    y1: 422.34,
    x2: 1199.46,
    y2: 415.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1199.46,
    y1: 422.34,
    x2: 1204.09,
    y2: 422.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1199.46,
    y1: 415.28,
    x2: 1204.09,
    y2: 415.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1203.78,
    y1: 409.52,
    x2: 1203.78,
    y2: 415.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1201.52,
    y1: 409.52,
    x2: 1201.52,
    y2: 415.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1204.6,
    y1: 453.22,
    x2: 1204.6,
    y2: 445.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1204.6,
    y1: 453.22,
    x2: 1232.81,
    y2: 453.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1204.6,
    y1: 445.85,
    x2: 1232.81,
    y2: 445.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1223.34,
    y1: 383.49,
    x2: 1201,
    y2: 383.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1201,
    y1: 383.49,
    x2: 1201,
    y2: 391.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1223.34,
    y1: 391.77,
    x2: 1223.34,
    y2: 383.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1201,
    y1: 391.77,
    x2: 1223.34,
    y2: 391.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1220.04,
    y1: 416.59,
    x2: 1240.32,
    y2: 416.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1220.04,
    y1: 420.62,
    x2: 1240.32,
    y2: 420.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1018.4,
    y1: 309.43,
    x2: 1018.4,
    y2: 325.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1014.79,
    y1: 325.37,
    x2: 1014.79,
    y2: 309.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1102.18,
    y1: 242.03,
    x2: 1102.18,
    y2: 256.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1089.11,
    y1: 264.73,
    x2: 1057.51,
    y2: 264.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1089.11,
    y1: 264.73,
    x2: 1089.11,
    y2: 256.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1030.95,
    y1: 242.03,
    x2: 1030.95,
    y2: 256.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1057,
    y1: 256.36,
    x2: 1030.95,
    y2: 256.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1102.18,
    y1: 242.03,
    x2: 1030.95,
    y2: 242.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1057.51,
    y1: 264.73,
    x2: 1057.51,
    y2: 242.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1057,
    y1: 242.03,
    x2: 1057,
    y2: 256.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1089.11,
    y1: 256.36,
    x2: 1102.18,
    y2: 256.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1036.92,
    y1: 262.91,
    x2: 1047.94,
    y2: 262.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1047.94,
    y1: 262.91,
    x2: 1047.94,
    y2: 258.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1047.94,
    y1: 258.37,
    x2: 1036.92,
    y2: 258.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1036.92,
    y1: 258.37,
    x2: 1036.92,
    y2: 262.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1018.4,
    y1: 290.76,
    x2: 1018.4,
    y2: 309.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1014.79,
    y1: 290.76,
    x2: 1014.79,
    y2: 309.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1056.69,
    y1: 287.94,
    x2: 1018.4,
    y2: 287.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1056.69,
    y1: 284.2,
    x2: 1018.4,
    y2: 284.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1018.4,
    y1: 325.37,
    x2: 1014.79,
    y2: 325.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1018.4,
    y1: 290.76,
    x2: 1014.79,
    y2: 290.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1018.4,
    y1: 245.76,
    x2: 1018.4,
    y2: 290.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1014.79,
    y1: 245.76,
    x2: 1014.79,
    y2: 290.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1094.46,
    y1: 287.94,
    x2: 1056.69,
    y2: 287.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1094.46,
    y1: 284.2,
    x2: 1056.69,
    y2: 284.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1056.69,
    y1: 284.2,
    x2: 1056.69,
    y2: 287.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1132.55,
    y1: 287.94,
    x2: 1094.46,
    y2: 287.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1132.55,
    y1: 284.2,
    x2: 1094.46,
    y2: 284.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1094.46,
    y1: 284.2,
    x2: 1094.46,
    y2: 287.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1153.96,
    y1: 339.8,
    x2: 1150.05,
    y2: 339.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1150.05,
    y1: 339.8,
    x2: 1150.05,
    y2: 346.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1156.74,
    y1: 352.41,
    x2: 1149.02,
    y2: 352.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1156.74,
    y1: 346.06,
    x2: 1149.02,
    y2: 346.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1156.74,
    y1: 346.06,
    x2: 1156.74,
    y2: 352.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1149.02,
    y1: 346.06,
    x2: 1149.02,
    y2: 352.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1153.96,
    y1: 339.8,
    x2: 1153.96,
    y2: 346.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1166.21,
    y1: 351.1,
    x2: 1156.74,
    y2: 351.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1166.21,
    y1: 347.07,
    x2: 1156.74,
    y2: 347.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1196.06,
    y1: 356.65,
    x2: 1183.5,
    y2: 356.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1196.06,
    y1: 364.72,
    x2: 1196.06,
    y2: 356.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1196.06,
    y1: 342.83,
    x2: 1196.06,
    y2: 364.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1177.33,
    y1: 341.32,
    x2: 1166.21,
    y2: 341.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1183.5,
    y1: 356.65,
    x2: 1196.06,
    y2: 356.65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1183.5,
    y1: 343.03,
    x2: 1196.06,
    y2: 343.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1166.21,
    y1: 357.46,
    x2: 1183.5,
    y2: 357.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1166.21,
    y1: 357.46,
    x2: 1166.21,
    y2: 341.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1183.5,
    y1: 357.46,
    x2: 1183.5,
    y2: 341.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1166.21,
    y1: 341.32,
    x2: 1183.5,
    y2: 341.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1196.06,
    y1: 342.83,
    x2: 1220.76,
    y2: 342.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1196.06,
    y1: 364.72,
    x2: 1220.76,
    y2: 364.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1196.06,
    y1: 364.72,
    x2: 1247.22,
    y2: 364.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1196.06,
    y1: 342.83,
    x2: 1248.04,
    y2: 342.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1163.43,
    y1: 247.07,
    x2: 1138.01,
    y2: 247.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1163.43,
    y1: 250.81,
    x2: 1138.01,
    y2: 250.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1163.43,
    y1: 247.07,
    x2: 1163.43,
    y2: 250.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1138.01,
    y1: 247.07,
    x2: 1138.01,
    y2: 250.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1149.84,
    y1: 293.49,
    x2: 1149.84,
    y2: 287.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1149.84,
    y1: 284.2,
    x2: 1149.84,
    y2: 251.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1153.96,
    y1: 293.49,
    x2: 1153.96,
    y2: 251.11
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1153.96,
    y1: 339.8,
    x2: 1153.96,
    y2: 338.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1153.96,
    y1: 338.99,
    x2: 1149.84,
    y2: 338.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1150.05,
    y1: 339.8,
    x2: 1150.05,
    y2: 338.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1153.96,
    y1: 339.8,
    x2: 1150.05,
    y2: 339.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1149.84,
    y1: 338.99,
    x2: 1149.84,
    y2: 293.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1153.96,
    y1: 338.99,
    x2: 1153.96,
    y2: 293.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1153.96,
    y1: 293.49,
    x2: 1149.84,
    y2: 293.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1153.96,
    y1: 339.8,
    x2: 1151.9,
    y2: 339.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1149.84,
    y1: 287.94,
    x2: 1132.55,
    y2: 287.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1149.84,
    y1: 284.2,
    x2: 1132.55,
    y2: 284.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1132.55,
    y1: 284.2,
    x2: 1132.55,
    y2: 287.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1114.85,
    y1: 284.2,
    x2: 1114.85,
    y2: 287.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 869.55,
    y1: 295,
    x2: 869.55,
    y2: 292.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 855.86,
    y1: 298.53,
    x2: 855.86,
    y2: 274.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 869.25,
    y1: 298.53,
    x2: 855.86,
    y2: 298.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 859.78,
    y1: 274.62,
    x2: 855.86,
    y2: 274.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 869.55,
    y1: 243.24,
    x2: 861.83,
    y2: 243.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 861.83,
    y1: 243.24,
    x2: 861.83,
    y2: 257.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 869.55,
    y1: 243.24,
    x2: 869.55,
    y2: 298.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 855.86,
    y1: 298.53,
    x2: 855.86,
    y2: 274.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 869.25,
    y1: 298.53,
    x2: 855.86,
    y2: 298.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 859.78,
    y1: 257.16,
    x2: 859.78,
    y2: 274.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 859.78,
    y1: 274.62,
    x2: 855.86,
    y2: 274.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 869.55,
    y1: 298.53,
    x2: 855.86,
    y2: 298.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 859.78,
    y1: 274.62,
    x2: 855.86,
    y2: 274.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 872.64,
    y1: 254.34,
    x2: 910.42,
    y2: 254.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 872.64,
    y1: 283.4,
    x2: 910.42,
    y2: 283.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 870.07,
    y1: 252.12,
    x2: 873.88,
    y2: 252.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1033.53,
    y1: 276.64,
    x2: 994.21,
    y2: 276.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1033.53,
    y1: 261.2,
    x2: 1024.88,
    y2: 261.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1033.53,
    y1: 276.64,
    x2: 1033.53,
    y2: 261.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1014.79,
    y1: 276.64,
    x2: 1014.79,
    y2: 261.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 911.96,
    y1: 258.37,
    x2: 911.96,
    y2: 279.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 994.21,
    y1: 279.66,
    x2: 994.21,
    y2: 258.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 911.96,
    y1: 258.37,
    x2: 994.21,
    y2: 258.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 911.96,
    y1: 279.66,
    x2: 994.21,
    y2: 279.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1007.07,
    y1: 259.38,
    x2: 994.21,
    y2: 259.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 902.18,
    y1: 250.81,
    x2: 873.88,
    y2: 250.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 902.18,
    y1: 227.6,
    x2: 873.88,
    y2: 227.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 873.88,
    y1: 250.81,
    x2: 873.88,
    y2: 227.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 902.18,
    y1: 250.81,
    x2: 902.18,
    y2: 227.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 872.64,
    y1: 279.66,
    x2: 872.64,
    y2: 283.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 909.9,
    y1: 278.35,
    x2: 909.9,
    y2: 283.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 909.9,
    y1: 278.35,
    x2: 909.9,
    y2: 254.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 872.64,
    y1: 279.66,
    x2: 872.64,
    y2: 254.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 872.64,
    y1: 254.34,
    x2: 910.42,
    y2: 254.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 910.42,
    y1: 278.35,
    x2: 910.42,
    y2: 283.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 872.64,
    y1: 283.4,
    x2: 910.42,
    y2: 283.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 872.64,
    y1: 279.66,
    x2: 872.64,
    y2: 283.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 908.05,
    y1: 229.82,
    x2: 908.05,
    y2: 252.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 902.18,
    y1: 252.12,
    x2: 902.18,
    y2: 229.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 902.18,
    y1: 252.12,
    x2: 908.05,
    y2: 252.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 908.05,
    y1: 229.82,
    x2: 902.18,
    y2: 229.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 873.88,
    y1: 252.12,
    x2: 873.88,
    y2: 230.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 870.07,
    y1: 230.63,
    x2: 870.07,
    y2: 252.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 870.07,
    y1: 252.12,
    x2: 873.88,
    y2: 252.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 870.07,
    y1: 230.63,
    x2: 873.88,
    y2: 230.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 865.44,
    y1: 328.4,
    x2: 865.44,
    y2: 298.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 862.35,
    y1: 328.4,
    x2: 862.35,
    y2: 298.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1013.76,
    y1: 245.76,
    x2: 1019.73,
    y2: 245.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1019.73,
    y1: 245.76,
    x2: 1019.73,
    y2: 241.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1019.73,
    y1: 241.22,
    x2: 1013.76,
    y2: 241.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1013.76,
    y1: 241.22,
    x2: 1013.76,
    y2: 245.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1198.63,
    y1: 392.57,
    x2: 1189.37,
    y2: 392.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1189.37,
    y1: 392.57,
    x2: 1189.37,
    y2: 383.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1189.37,
    y1: 383.19,
    x2: 1198.63,
    y2: 383.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1198.63,
    y1: 383.19,
    x2: 1198.63,
    y2: 392.57
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1117.11,
    y1: 246.06,
    x2: 1117.42,
    y2: 246.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1117.11,
    y1: 251.82,
    x2: 1117.42,
    y2: 251.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1102.18,
    y1: 251.82,
    x2: 1117.11,
    y2: 251.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1117.11,
    y1: 246.06,
    x2: 1102.18,
    y2: 246.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1117.11,
    y1: 246.06,
    x2: 1117.11,
    y2: 251.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1138.01,
    y1: 251.82,
    x2: 1117.42,
    y2: 251.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1117.42,
    y1: 251.82,
    x2: 1117.42,
    y2: 246.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1117.42,
    y1: 246.06,
    x2: 1138.01,
    y2: 246.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1138.01,
    y1: 246.06,
    x2: 1138.01,
    y2: 251.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 961.06,
    y1: 447.67,
    x2: 872.13,
    y2: 447.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1125.34,
    y1: 438.28,
    x2: 961.06,
    y2: 438.28
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 961.06,
    y1: 438.28,
    x2: 961.06,
    y2: 447.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 872.13,
    y1: 380.67,
    x2: 872.13,
    y2: 447.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1128.43,
    y1: 358.97,
    x2: 1113.3,
    y2: 358.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1112.27,
    y1: 358.97,
    x2: 1113.3,
    y2: 358.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1128.43,
    y1: 318.31,
    x2: 1112.27,
    y2: 318.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1128.43,
    y1: 358.97,
    x2: 1128.43,
    y2: 300.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1128.43,
    y1: 300.05,
    x2: 885.51,
    y2: 300.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1112.27,
    y1: 318.31,
    x2: 1112.27,
    y2: 300.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1164.46,
    y1: 247.07,
    x2: 1174.44,
    y2: 247.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1174.75,
    y1: 247.07,
    x2: 1174.44,
    y2: 247.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1174.75,
    y1: 247.07,
    x2: 1174.96,
    y2: 247.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1174.75,
    y1: 250.81,
    x2: 1174.75,
    y2: 247.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1174.75,
    y1: 250.81,
    x2: 1174.96,
    y2: 250.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1174.75,
    y1: 250.81,
    x2: 1163.64,
    y2: 250.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1163.64,
    y1: 247.07,
    x2: 1163.64,
    y2: 250.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1163.64,
    y1: 250.81,
    x2: 1164.15,
    y2: 250.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1163.64,
    y1: 247.07,
    x2: 1164.15,
    y2: 247.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1163.64,
    y1: 247.07,
    x2: 1164.46,
    y2: 247.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1164.46,
    y1: 250.81,
    x2: 1164.46,
    y2: 253.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1167.03,
    y1: 244.55,
    x2: 1164.46,
    y2: 244.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1164.46,
    y1: 253.33,
    x2: 1167.03,
    y2: 253.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1164.46,
    y1: 244.55,
    x2: 1164.46,
    y2: 247.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1167.03,
    y1: 250.81,
    x2: 1167.03,
    y2: 253.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1167.03,
    y1: 244.55,
    x2: 1167.03,
    y2: 247.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1148.81,
    y1: 420.62,
    x2: 1148.81,
    y2: 416.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1148.81,
    y1: 416.59,
    x2: 1183.19,
    y2: 416.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1148.81,
    y1: 420.62,
    x2: 1183.19,
    y2: 420.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1183.19,
    y1: 420.62,
    x2: 1183.19,
    y2: 416.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1221.59,
    y1: 313.77,
    x2: 1198.94,
    y2: 313.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1198.94,
    y1: 313.77,
    x2: 1198.94,
    y2: 299.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1198.94,
    y1: 299.04,
    x2: 1221.59,
    y2: 299.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1221.59,
    y1: 299.04,
    x2: 1221.59,
    y2: 313.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1024.88,
    y1: 261.2,
    x2: 1024.88,
    y2: 245.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1024.88,
    y1: 245.05,
    x2: 1007.07,
    y2: 245.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1007.07,
    y1: 245.05,
    x2: 1007.07,
    y2: 259.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 861.83,
    y1: 257.16,
    x2: 859.78,
    y2: 257.16
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1203.78 409.52 1203.57 408.72 1202.75 408.52 1202.03 408.72 1201.52 409.52 1202.03 410.23 1202.75 410.23 1203.57 410.23 1203.78 409.52"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1175.47,
    y1: 299.04,
    x2: 1194.31,
    y2: 299.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1194.31,
    y1: 304.38,
    x2: 1194.31,
    y2: 299.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1194.31,
    y1: 304.38,
    x2: 1194.52,
    y2: 304.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1194.52,
    y1: 309.23,
    x2: 1194.52,
    y2: 304.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1193.8,
    y1: 309.23,
    x2: 1194.52,
    y2: 309.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1147.99,
    y1: 314.27,
    x2: 1193.8,
    y2: 314.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1193.8,
    y1: 314.27,
    x2: 1193.8,
    y2: 309.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1147.99,
    y1: 299.34,
    x2: 1175.47,
    y2: 299.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1175.47,
    y1: 299.04,
    x2: 1175.47,
    y2: 299.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1194.31,
    y1: 299.34,
    x2: 1194.31,
    y2: 299.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1147.99,
    y1: 299.34,
    x2: 1147.99,
    y2: 314.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1030.95,
    y1: 251.31,
    x2: 1024.88,
    y2: 251.31
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1030.95,
    y1: 247.58,
    x2: 1024.88,
    y2: 247.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1119.68,
    y1: 484.8,
    x2: 1119.68,
    y2: 480.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1132.86,
    y1: 484.8,
    x2: 1132.86,
    y2: 480.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1119.68,
    y1: 480.46,
    x2: 1132.86,
    y2: 480.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1119.68,
    y1: 484.8,
    x2: 1132.86,
    y2: 484.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1131.01,
    y1: 477.94,
    x2: 1110.42,
    y2: 477.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1110.42,
    y1: 490.35,
    x2: 1131.01,
    y2: 490.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1118.14,
    y1: 480.26,
    x2: 1110.73,
    y2: 480.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1118.14,
    y1: 474.4,
    x2: 1118.14,
    y2: 480.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1110.73,
    y1: 480.26,
    x2: 1110.73,
    y2: 474.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1118.14,
    y1: 474.4,
    x2: 1110.73,
    y2: 474.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1131.01,
    y1: 477.94,
    x2: 1131.01,
    y2: 490.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1110.42,
    y1: 477.94,
    x2: 1110.42,
    y2: 490.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1100.43,
    y1: 481.97,
    x2: 1100.43,
    y2: 478.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1081.7,
    y1: 478.44,
    x2: 1082.21,
    y2: 478.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1082.42,
    y1: 478.44,
    x2: 1082.94,
    y2: 478.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1082.42,
    y1: 478.44,
    x2: 1082.94,
    y2: 478.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1081.7,
    y1: 478.44,
    x2: 1082.42,
    y2: 478.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1081.39,
    y1: 491.05,
    x2: 1081.39,
    y2: 478.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1100.43,
    y1: 491.05,
    x2: 1100.43,
    y2: 478.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1100.43,
    y1: 491.05,
    x2: 1081.39,
    y2: 491.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1100.43,
    y1: 478.44,
    x2: 1081.39,
    y2: 478.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1100.43,
    y1: 478.44,
    x2: 1081.39,
    y2: 478.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1109.7,
    y1: 480.96,
    x2: 1109.7,
    y2: 484.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1100.43,
    y1: 480.96,
    x2: 1109.7,
    y2: 480.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1100.43,
    y1: 484.49,
    x2: 1109.7,
    y2: 484.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1142.84,
    y1: 494.69,
    x2: 1147.99,
    y2: 494.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1132.86,
    y1: 481.27,
    x2: 1156.53,
    y2: 481.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1132.86,
    y1: 483.99,
    x2: 1156.53,
    y2: 483.99
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1144.9,
    y1: 473.9,
    x2: 1137.7,
    y2: 473.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1144.9,
    y1: 478.44,
    x2: 1144.9,
    y2: 473.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1137.7,
    y1: 478.44,
    x2: 1137.7,
    y2: 473.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1154.17,
    y1: 475.41,
    x2: 1154.17,
    y2: 478.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1154.17,
    y1: 478.74,
    x2: 1146.45,
    y2: 478.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1154.17,
    y1: 475.41,
    x2: 1146.45,
    y2: 475.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1151.9,
    y1: 494.69,
    x2: 1137.7,
    y2: 494.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1151.9,
    y1: 478.44,
    x2: 1151.9,
    y2: 494.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1137.7,
    y1: 478.44,
    x2: 1137.7,
    y2: 494.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1137.7,
    y1: 478.44,
    x2: 1151.9,
    y2: 478.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1146.45,
    y1: 475.41,
    x2: 1146.45,
    y2: 478.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1177.33,
    y1: 480.96,
    x2: 1178.05,
    y2: 480.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1177.33,
    y1: 484.49,
    x2: 1178.05,
    y2: 484.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1177.33,
    y1: 480.96,
    x2: 1177.33,
    y2: 484.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1157.56,
    y1: 480.96,
    x2: 1177.33,
    y2: 480.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1157.56,
    y1: 484.49,
    x2: 1177.33,
    y2: 484.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1177.33,
    y1: 484.49,
    x2: 1177.33,
    y2: 480.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1156.53,
    y1: 480.96,
    x2: 1157.56,
    y2: 480.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1156.53,
    y1: 484.49,
    x2: 1157.56,
    y2: 484.49
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1156.53,
    y1: 480.96,
    x2: 1156.53,
    y2: 484.49
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 929.5,
    y1: 567.67,
    x2: 929.81,
    y2: 567.67
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 929.5,
    y1: 571.7,
    x2: 929.81,
    y2: 571.7
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 768.27,
    y1: 567.67,
    x2: 768.78,
    y2: 567.67
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 768.27,
    y1: 571.7,
    x2: 768.78,
    y2: 571.7
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 606.94,
    y1: 567.67,
    x2: 607.45,
    y2: 567.67
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 603.03,
    y1: 567.67,
    x2: 603.34,
    y2: 567.67
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 606.94,
    y1: 571.7,
    x2: 607.45,
    y2: 571.7
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 603.03,
    y1: 571.7,
    x2: 603.34,
    y2: 571.7
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 441.8,
    y1: 567.67,
    x2: 442,
    y2: 567.67
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 441.8,
    y1: 571.7,
    x2: 442,
    y2: 571.7
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 280.46,
    y1: 567.67,
    x2: 280.98,
    y2: 567.67
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 280.46,
    y1: 571.7,
    x2: 280.98,
    y2: 571.7
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 280.46,
    y1: 345.82,
    x2: 280.98,
    y2: 345.82
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 441.8,
    y1: 345.82,
    x2: 442,
    y2: 345.82
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 606.94,
    y1: 345.82,
    x2: 607.45,
    y2: 345.82
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 603.03,
    y1: 345.82,
    x2: 603.34,
    y2: 345.82
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 768.27,
    y1: 345.82,
    x2: 768.78,
    y2: 345.82
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 929.5,
    y1: 345.82,
    x2: 929.81,
    y2: 345.82
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 929.5,
    y1: 567.67,
    x2: 925.39,
    y2: 567.67
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 929.5,
    y1: 571.7,
    x2: 929.5,
    y2: 567.67
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 929.5,
    y1: 567.47,
    x2: 925.39,
    y2: 567.47
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 929.81,
    y1: 567.67,
    x2: 929.5,
    y2: 567.47
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 929.81,
    y1: 571.7,
    x2: 929.81,
    y2: 567.67
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 925.18,
    y1: 567.67,
    x2: 925.18,
    y2: 571.7
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 925.39,
    y1: 567.67,
    x2: 925.18,
    y2: 567.67
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 925.18,
    y1: 567.67,
    x2: 925.18,
    y2: 571.7
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "925.39 567.47 925.18 567.47 925.18 567.67"
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 925.39,
    y1: 571.7,
    x2: 929.5,
    y2: 571.7
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 929.5,
    y1: 572,
    x2: 929.81,
    y2: 571.7
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 925.39,
    y1: 572,
    x2: 929.5,
    y2: 572
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 925.18,
    y1: 571.7,
    x2: 925.39,
    y2: 571.7
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "925.18 571.7 925.18 572 925.39 572"
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 768.27,
    y1: 567.67,
    x2: 764.16,
    y2: 567.67
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 768.27,
    y1: 571.7,
    x2: 768.27,
    y2: 567.67
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 768.27,
    y1: 567.47,
    x2: 764.16,
    y2: 567.47
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "768.78 567.67 768.78 567.47 768.27 567.47"
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 768.78,
    y1: 571.7,
    x2: 768.78,
    y2: 567.67
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 763.85,
    y1: 567.67,
    x2: 763.85,
    y2: 571.7
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 764.16,
    y1: 567.67,
    x2: 763.85,
    y2: 567.67
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 763.85,
    y1: 567.67,
    x2: 763.85,
    y2: 571.7
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "764.16 567.47 763.85 567.47 763.85 567.67"
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 764.16,
    y1: 571.7,
    x2: 768.27,
    y2: 571.7
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "768.27 572 768.78 572 768.78 571.7"
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 764.16,
    y1: 572,
    x2: 768.27,
    y2: 572
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 763.85,
    y1: 571.7,
    x2: 764.16,
    y2: 571.7
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "763.85 571.7 763.85 572 764.16 572"
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 606.94,
    y1: 567.67,
    x2: 603.03,
    y2: 567.67
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 606.94,
    y1: 571.7,
    x2: 606.94,
    y2: 567.67
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 606.94,
    y1: 567.47,
    x2: 603.03,
    y2: 567.47
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "607.45 567.67 607.45 567.47 606.94 567.47"
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 607.45,
    y1: 571.7,
    x2: 607.45,
    y2: 567.67
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 603.03,
    y1: 567.67,
    x2: 603.03,
    y2: 571.7
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 602.51,
    y1: 567.67,
    x2: 602.51,
    y2: 571.7
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "603.03 567.47 602.51 567.47 602.51 567.67"
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 603.03,
    y1: 571.7,
    x2: 606.94,
    y2: 571.7
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "606.94 572 607.45 572 607.45 571.7"
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 603.03,
    y1: 572,
    x2: 606.94,
    y2: 572
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "602.51 571.7 602.51 572 603.03 572"
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 445.91,
    y1: 567.67,
    x2: 441.8,
    y2: 567.67
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 446.12,
    y1: 567.67,
    x2: 445.91,
    y2: 567.67
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 446.12,
    y1: 571.7,
    x2: 446.12,
    y2: 567.67
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 445.91,
    y1: 567.47,
    x2: 441.8,
    y2: 567.47
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "446.12 567.67 446.12 567.47 445.91 567.47"
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 446.12,
    y1: 571.7,
    x2: 446.12,
    y2: 567.67
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 441.8,
    y1: 567.67,
    x2: 441.8,
    y2: 571.7
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 441.28,
    y1: 567.67,
    x2: 441.28,
    y2: 571.7
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "441.8 567.47 441.28 567.47 441.28 567.67"
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 445.91,
    y1: 571.7,
    x2: 446.12,
    y2: 571.7
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 441.8,
    y1: 571.7,
    x2: 445.91,
    y2: 571.7
  })), _polyline13 || (_polyline13 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "445.91 572 446.12 572 446.12 571.7"
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 441.8,
    y1: 572,
    x2: 445.91,
    y2: 572
  })), _polyline14 || (_polyline14 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "441.28 571.7 441.28 572 441.8 572"
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 284.58,
    y1: 567.67,
    x2: 280.46,
    y2: 567.67
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 284.78,
    y1: 567.67,
    x2: 284.58,
    y2: 567.67
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 284.78,
    y1: 571.7,
    x2: 284.78,
    y2: 567.67
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 284.58,
    y1: 567.47,
    x2: 280.46,
    y2: 567.47
  })), _polyline15 || (_polyline15 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "284.78 567.67 284.78 567.47 284.58 567.47"
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 284.78,
    y1: 571.7,
    x2: 284.78,
    y2: 567.67
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 280.46,
    y1: 567.67,
    x2: 280.46,
    y2: 571.7
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 280.16,
    y1: 567.67,
    x2: 280.16,
    y2: 571.7
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 280.46,
    y1: 567.47,
    x2: 280.16,
    y2: 567.67
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 284.58,
    y1: 571.7,
    x2: 284.78,
    y2: 571.7
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 280.46,
    y1: 571.7,
    x2: 284.58,
    y2: 571.7
  })), _polyline16 || (_polyline16 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "284.58 572 284.78 572 284.78 571.7"
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 280.46,
    y1: 572,
    x2: 284.58,
    y2: 572
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 280.16,
    y1: 571.7,
    x2: 280.46,
    y2: 572
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 284.58,
    y1: 341.28,
    x2: 280.46,
    y2: 341.28
  })), _polyline17 || (_polyline17 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "284.78 341.78 284.78 341.28 284.58 341.28"
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 284.78,
    y1: 345.82,
    x2: 284.78,
    y2: 341.78
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 284.58,
    y1: 341.28,
    x2: 280.46,
    y2: 341.28
  })), _polyline18 || (_polyline18 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "284.78 341.78 284.78 341.28 284.58 341.28"
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 284.78,
    y1: 345.82,
    x2: 284.78,
    y2: 341.78
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 280.46,
    y1: 341.78,
    x2: 280.46,
    y2: 345.82
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 280.46,
    y1: 341.28,
    x2: 280.46,
    y2: 341.78
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 280.16,
    y1: 341.78,
    x2: 280.16,
    y2: 345.82
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 280.46,
    y1: 341.28,
    x2: 280.16,
    y2: 341.78
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 284.58,
    y1: 345.82,
    x2: 284.78,
    y2: 345.82
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 280.46,
    y1: 345.82,
    x2: 284.58,
    y2: 345.82
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 284.58,
    y1: 346.12,
    x2: 284.78,
    y2: 345.82
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 280.46,
    y1: 346.12,
    x2: 284.58,
    y2: 346.12
  })), _polyline19 || (_polyline19 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "280.16 345.82 280.46 345.82 280.46 346.12"
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 445.91,
    y1: 341.28,
    x2: 441.8,
    y2: 341.28
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 446.12,
    y1: 341.78,
    x2: 445.91,
    y2: 341.28
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 446.12,
    y1: 345.82,
    x2: 446.12,
    y2: 341.78
  })), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 445.91,
    y1: 341.28,
    x2: 441.8,
    y2: 341.28
  })), _polyline20 || (_polyline20 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "446.12 341.78 446.12 341.28 445.91 341.28"
  })), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 446.12,
    y1: 345.82,
    x2: 446.12,
    y2: 341.78
  })), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 441.8,
    y1: 341.78,
    x2: 441.8,
    y2: 345.82
  })), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 441.8,
    y1: 341.28,
    x2: 441.8,
    y2: 341.78
  })), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 441.28,
    y1: 341.78,
    x2: 441.28,
    y2: 345.82
  })), _polyline21 || (_polyline21 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "441.8 341.28 441.28 341.28 441.28 341.78"
  })), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 445.91,
    y1: 345.82,
    x2: 446.12,
    y2: 345.82
  })), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 441.8,
    y1: 345.82,
    x2: 445.91,
    y2: 345.82
  })), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 445.91,
    y1: 346.12,
    x2: 446.12,
    y2: 345.82
  })), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 441.8,
    y1: 346.12,
    x2: 445.91,
    y2: 346.12
  })), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 441.28,
    y1: 345.82,
    x2: 441.8,
    y2: 346.12
  })), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 606.94,
    y1: 341.28,
    x2: 603.03,
    y2: 341.28
  })), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 606.94,
    y1: 341.78,
    x2: 606.94,
    y2: 341.28
  })), _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 606.94,
    y1: 345.82,
    x2: 606.94,
    y2: 341.78
  })), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 606.94,
    y1: 341.28,
    x2: 603.03,
    y2: 341.28
  })), _polyline22 || (_polyline22 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "607.45 341.78 607.45 341.28 606.94 341.28"
  })), _line100 || (_line100 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 607.45,
    y1: 345.82,
    x2: 607.45,
    y2: 341.78
  })), _line101 || (_line101 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 603.03,
    y1: 341.78,
    x2: 603.03,
    y2: 345.82
  })), _line102 || (_line102 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 603.03,
    y1: 341.28,
    x2: 603.03,
    y2: 341.78
  })), _line103 || (_line103 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 602.51,
    y1: 341.78,
    x2: 602.51,
    y2: 345.82
  })), _polyline23 || (_polyline23 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "603.03 341.28 602.51 341.28 602.51 341.78"
  })), _line104 || (_line104 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 603.03,
    y1: 345.82,
    x2: 606.94,
    y2: 345.82
  })), _line105 || (_line105 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 606.94,
    y1: 346.12,
    x2: 607.45,
    y2: 345.82
  })), _line106 || (_line106 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 603.03,
    y1: 346.12,
    x2: 606.94,
    y2: 346.12
  })), _line107 || (_line107 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 602.51,
    y1: 345.82,
    x2: 603.03,
    y2: 346.12
  })), _line108 || (_line108 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 768.27,
    y1: 341.28,
    x2: 764.16,
    y2: 341.28
  })), _line109 || (_line109 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 768.27,
    y1: 341.78,
    x2: 768.27,
    y2: 341.28
  })), _line110 || (_line110 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 768.27,
    y1: 345.82,
    x2: 768.27,
    y2: 341.78
  })), _line111 || (_line111 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 768.27,
    y1: 341.28,
    x2: 764.16,
    y2: 341.28
  })), _polyline24 || (_polyline24 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "768.78 341.78 768.78 341.28 768.27 341.28"
  })), _line112 || (_line112 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 768.78,
    y1: 345.82,
    x2: 768.78,
    y2: 341.78
  })), _line113 || (_line113 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 763.85,
    y1: 341.78,
    x2: 763.85,
    y2: 345.82
  })), _polyline25 || (_polyline25 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "764.16 341.28 763.85 341.28 763.85 341.78"
  })), _line114 || (_line114 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 763.85,
    y1: 341.78,
    x2: 763.85,
    y2: 345.82
  })), _polyline26 || (_polyline26 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "764.16 341.28 763.85 341.28 763.85 341.78"
  })), _line115 || (_line115 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 764.16,
    y1: 345.82,
    x2: 768.27,
    y2: 345.82
  })), _line116 || (_line116 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 768.27,
    y1: 346.12,
    x2: 768.78,
    y2: 345.82
  })), _line117 || (_line117 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 764.16,
    y1: 346.12,
    x2: 768.27,
    y2: 346.12
  })), _line118 || (_line118 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 763.85,
    y1: 345.82,
    x2: 764.16,
    y2: 345.82
  })), _line119 || (_line119 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 763.85,
    y1: 345.82,
    x2: 764.16,
    y2: 346.12
  })), _line120 || (_line120 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 929.5,
    y1: 341.28,
    x2: 925.39,
    y2: 341.28
  })), _line121 || (_line121 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 929.5,
    y1: 341.78,
    x2: 929.5,
    y2: 341.28
  })), _line122 || (_line122 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 929.5,
    y1: 345.82,
    x2: 929.5,
    y2: 341.78
  })), _line123 || (_line123 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 929.5,
    y1: 341.28,
    x2: 925.39,
    y2: 341.28
  })), _line124 || (_line124 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 929.81,
    y1: 341.78,
    x2: 929.5,
    y2: 341.28
  })), _line125 || (_line125 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 929.81,
    y1: 345.82,
    x2: 929.81,
    y2: 341.78
  })), _line126 || (_line126 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 925.18,
    y1: 341.78,
    x2: 925.18,
    y2: 345.82
  })), _polyline27 || (_polyline27 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "925.39 341.28 925.18 341.28 925.18 341.78"
  })), _line127 || (_line127 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 925.18,
    y1: 341.78,
    x2: 925.18,
    y2: 345.82
  })), _polyline28 || (_polyline28 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "925.39 341.28 925.18 341.28 925.18 341.78"
  })), _line128 || (_line128 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 925.39,
    y1: 345.82,
    x2: 929.5,
    y2: 345.82
  })), _polyline29 || (_polyline29 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "929.5 346.12 929.5 345.82 929.81 345.82"
  })), _line129 || (_line129 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 925.39,
    y1: 346.12,
    x2: 929.5,
    y2: 346.12
  })), _line130 || (_line130 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 925.18,
    y1: 345.82,
    x2: 925.39,
    y2: 345.82
  })), _line131 || (_line131 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 925.18,
    y1: 345.82,
    x2: 925.39,
    y2: 346.12
  })), _line132 || (_line132 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 215.68,
    y1: 560.91,
    x2: 215.68,
    y2: 268.91
  })), _line133 || (_line133 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1014.84,
    y1: 579.26,
    x2: 235.02,
    y2: 579.26
  })), _line134 || (_line134 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 225.76,
    y1: 259.23,
    x2: 215.68,
    y2: 268.91
  })), _line135 || (_line135 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1014.84,
    y1: 579.26,
    x2: 1014.84,
    y2: 277.98
  })), _line136 || (_line136 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 995.51,
    y1: 259.23,
    x2: 225.76,
    y2: 259.23
  })), _line137 || (_line137 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 995.51,
    y1: 259.23,
    x2: 1014.84,
    y2: 277.98
  })), _line138 || (_line138 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 235.02,
    y1: 579.26,
    x2: 215.68,
    y2: 560.91
  })), _line139 || (_line139 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 249.41,
    y1: 572.71,
    x2: 249.41,
    y2: 525.54
  })), _line140 || (_line140 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 249.41,
    y1: 525.54,
    x2: 226.48,
    y2: 525.54
  })), _line141 || (_line141 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.48,
    y1: 525.54,
    x2: 226.48,
    y2: 572.71
  })), _line142 || (_line142 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.48,
    y1: 572.71,
    x2: 249.41,
    y2: 572.71
  })), _line143 || (_line143 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.48,
    y1: 572.71,
    x2: 249.41,
    y2: 525.54
  })), _line144 || (_line144 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.48,
    y1: 525.54,
    x2: 249.41,
    y2: 572.71
  })), _line145 || (_line145 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 249.41,
    y1: 525.54,
    x2: 249.41,
    y2: 478.36
  })), _line146 || (_line146 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 249.41,
    y1: 478.36,
    x2: 226.48,
    y2: 478.36
  })), _line147 || (_line147 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.48,
    y1: 478.36,
    x2: 226.48,
    y2: 525.54
  })), _line148 || (_line148 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.48,
    y1: 525.54,
    x2: 249.41,
    y2: 525.54
  })), _line149 || (_line149 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.48,
    y1: 525.54,
    x2: 249.41,
    y2: 478.36
  })), _line150 || (_line150 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.48,
    y1: 478.36,
    x2: 249.41,
    y2: 525.54
  })), _line151 || (_line151 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 249.41,
    y1: 478.36,
    x2: 249.41,
    y2: 431.19
  })), _line152 || (_line152 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 249.41,
    y1: 431.19,
    x2: 226.48,
    y2: 431.19
  })), _line153 || (_line153 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.48,
    y1: 431.19,
    x2: 226.48,
    y2: 478.36
  })), _line154 || (_line154 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.48,
    y1: 478.36,
    x2: 249.41,
    y2: 478.36
  })), _line155 || (_line155 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.48,
    y1: 478.36,
    x2: 249.41,
    y2: 431.19
  })), _line156 || (_line156 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 226.48,
    y1: 431.19,
    x2: 249.41,
    y2: 478.36
  })), _line157 || (_line157 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 259.59,
    y1: 563.64,
    x2: 282.73,
    y2: 563.64
  })), _line158 || (_line158 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 282.73,
    y1: 563.64,
    x2: 282.73,
    y2: 422.82
  })), _line159 || (_line159 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 282.73,
    y1: 422.82,
    x2: 259.59,
    y2: 422.82
  })), _line160 || (_line160 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 259.59,
    y1: 422.82,
    x2: 259.59,
    y2: 563.64
  })), _line161 || (_line161 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 259.59,
    y1: 493.28,
    x2: 282.73,
    y2: 493.28
  })), _line162 || (_line162 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 259.59,
    y1: 493.28,
    x2: 282.73,
    y2: 563.64
  })), _line163 || (_line163 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 282.73,
    y1: 493.28,
    x2: 259.59,
    y2: 563.64
  })), _line164 || (_line164 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 259.59,
    y1: 422.82,
    x2: 282.73,
    y2: 493.28
  })), _line165 || (_line165 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 282.73,
    y1: 422.82,
    x2: 259.59,
    y2: 493.28
  })), _line166 || (_line166 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 944.2,
    y1: 558.39,
    x2: 944.2,
    y2: 530.58
  })), _line167 || (_line167 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 944.2,
    y1: 530.58,
    x2: 915.93,
    y2: 530.58
  })), _line168 || (_line168 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 944.2,
    y1: 558.39,
    x2: 915.93,
    y2: 558.39
  })), _line169 || (_line169 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 915.93,
    y1: 558.39,
    x2: 915.93,
    y2: 530.58
  })), _line170 || (_line170 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 957.57,
    y1: 544.69,
    x2: 944.2,
    y2: 544.69
  })), _line171 || (_line171 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 957.57,
    y1: 548.21,
    x2: 944.2,
    y2: 548.21
  })), _line172 || (_line172 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 985.23,
    y1: 537.43,
    x2: 1003.74,
    y2: 537.43
  })), _line173 || (_line173 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1004.05,
    y1: 542.97,
    x2: 1004.05,
    y2: 537.93
  })), _line174 || (_line174 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1004.05,
    y1: 542.97,
    x2: 1004.56,
    y2: 542.97
  })), _line175 || (_line175 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1004.56,
    y1: 547.51,
    x2: 1004.56,
    y2: 542.97
  })), _line176 || (_line176 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1003.74,
    y1: 547.51,
    x2: 1004.56,
    y2: 547.51
  })), _line177 || (_line177 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 957.57,
    y1: 552.55,
    x2: 1003.74,
    y2: 552.55
  })), _line178 || (_line178 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1003.74,
    y1: 552.55,
    x2: 1003.74,
    y2: 547.51
  })), _line179 || (_line179 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 957.57,
    y1: 537.93,
    x2: 985.02,
    y2: 537.93
  })), _line180 || (_line180 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 985.23,
    y1: 537.43,
    x2: 985.02,
    y2: 537.93
  })), _polyline30 || (_polyline30 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "1004.05 537.93 1004.05 537.43 1003.74 537.43"
  })), _line181 || (_line181 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 957.57,
    y1: 537.93,
    x2: 957.57,
    y2: 552.55
  })), _line182 || (_line182 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 889.19,
    y1: 532.39,
    x2: 889.19,
    y2: 546.5
  })), _line183 || (_line183 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 825.23,
    y1: 546.5,
    x2: 812.69,
    y2: 546.5
  })), _line184 || (_line184 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 876.13,
    y1: 554.36,
    x2: 876.13,
    y2: 532.39
  })), _line185 || (_line185 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 889.19,
    y1: 546.5,
    x2: 876.13,
    y2: 546.5
  })), _line186 || (_line186 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 825.23,
    y1: 554.36,
    x2: 825.23,
    y2: 546.5
  })), _line187 || (_line187 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 915.93,
    y1: 537.13,
    x2: 889.19,
    y2: 537.13
  })), _line188 || (_line188 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 916.65,
    y1: 541.16,
    x2: 889.19,
    y2: 541.16
  })), _line189 || (_line189 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 878.39,
    y1: 532.39,
    x2: 889.19,
    y2: 532.39
  })), _line190 || (_line190 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 825.54,
    y1: 532.39,
    x2: 825.54,
    y2: 554.36
  })), _line191 || (_line191 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 806.52,
    y1: 531.08,
    x2: 795.41,
    y2: 531.08
  })), _line192 || (_line192 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 812.69,
    y1: 546.5,
    x2: 825.23,
    y2: 546.5
  })), _line193 || (_line193 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 812.69,
    y1: 533.1,
    x2: 825.23,
    y2: 533.1
  })), _line194 || (_line194 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 795.41,
    y1: 547.21,
    x2: 812.69,
    y2: 547.21
  })), _line195 || (_line195 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 795.41,
    y1: 547.21,
    x2: 795.41,
    y2: 531.08
  })), _line196 || (_line196 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 812.69,
    y1: 547.21,
    x2: 812.69,
    y2: 531.08
  })), _line197 || (_line197 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 795.41,
    y1: 531.08,
    x2: 812.69,
    y2: 531.08
  })), _line198 || (_line198 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 876.85,
    y1: 532.39,
    x2: 889.19,
    y2: 532.39
  })), _line199 || (_line199 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 876.85,
    y1: 546.5,
    x2: 889.19,
    y2: 546.5
  })), _line200 || (_line200 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 825.54,
    y1: 532.39,
    x2: 849.91,
    y2: 532.39
  })), _line201 || (_line201 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 825.54,
    y1: 554.36,
    x2: 849.91,
    y2: 554.36
  })), _line202 || (_line202 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 876.13,
    y1: 554.36,
    x2: 876.13,
    y2: 532.39
  })), _line203 || (_line203 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 825.54,
    y1: 554.36,
    x2: 876.13,
    y2: 554.36
  })), _line204 || (_line204 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 825.54,
    y1: 532.39,
    x2: 876.85,
    y2: 532.39
  })), _line205 || (_line205 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 821.94,
    y1: 508.4,
    x2: 821.94,
    y2: 501.04
  })), _line206 || (_line206 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 821.94,
    y1: 508.4,
    x2: 850.12,
    y2: 508.4
  })), _line207 || (_line207 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 850.12,
    y1: 508.4,
    x2: 850.12,
    y2: 501.04
  })), _line208 || (_line208 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 821.94,
    y1: 501.04,
    x2: 850.12,
    y2: 501.04
  })), _line209 || (_line209 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 822.66,
    y1: 306.2,
    x2: 813.2,
    y2: 306.2
  })), _line210 || (_line210 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 798.81,
    y1: 306.2,
    x2: 792.33,
    y2: 306.2
  })), _line211 || (_line211 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 822.66,
    y1: 302.47,
    x2: 813.2,
    y2: 302.47
  })), _line212 || (_line212 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 804.16,
    y1: 311.55,
    x2: 804.67,
    y2: 311.55
  })), _line213 || (_line213 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 792.33,
    y1: 306.2,
    x2: 792.84,
    y2: 306.2
  })), _line214 || (_line214 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 798.81,
    y1: 302.47,
    x2: 792.33,
    y2: 302.47
  })), _line215 || (_line215 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 798.81,
    y1: 302.47,
    x2: 798.81,
    y2: 306.2
  })), _line216 || (_line216 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 792.33,
    y1: 302.47,
    x2: 792.33,
    y2: 306.2
  })), _line217 || (_line217 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 813.2,
    y1: 292.29,
    x2: 798.81,
    y2: 292.29
  })), _line218 || (_line218 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 804.16,
    y1: 311.75,
    x2: 802.41,
    y2: 311.75
  })), _line219 || (_line219 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 802.41,
    y1: 308.72,
    x2: 802.41,
    y2: 311.75
  })), _line220 || (_line220 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 798.81,
    y1: 308.72,
    x2: 798.81,
    y2: 292.29
  })), _line221 || (_line221 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 813.2,
    y1: 308.72,
    x2: 813.2,
    y2: 292.29
  })), _line222 || (_line222 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 804.16,
    y1: 313.06,
    x2: 804.16,
    y2: 311.75
  })), _line223 || (_line223 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 813.2,
    y1: 308.72,
    x2: 798.81,
    y2: 308.72
  })), _line224 || (_line224 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 806.73,
    y1: 313.06,
    x2: 807.24,
    y2: 313.06
  })), _line225 || (_line225 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 804.16,
    y1: 313.06,
    x2: 806.73,
    y2: 313.06
  })), _line226 || (_line226 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 806.73,
    y1: 313.06,
    x2: 813.2,
    y2: 313.06
  })), _line227 || (_line227 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 813.2,
    y1: 308.72,
    x2: 813.2,
    y2: 313.06
  })), _line228 || (_line228 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 797.99,
    y1: 307.21,
    x2: 797.99,
    y2: 310.54
  })), _line229 || (_line229 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 797.99,
    y1: 310.54,
    x2: 790.27,
    y2: 310.54
  })), _line230 || (_line230 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 797.99,
    y1: 307.21,
    x2: 790.27,
    y2: 307.21
  })), _line231 || (_line231 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 790.27,
    y1: 307.21,
    x2: 790.27,
    y2: 310.54
  })), _line232 || (_line232 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 823.49,
    y1: 300.66,
    x2: 823.49,
    y2: 310.74
  })), _line233 || (_line233 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 853,
    y1: 300.66,
    x2: 823.49,
    y2: 300.66
  })), _line234 || (_line234 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 851.15,
    y1: 310.74,
    x2: 850.12,
    y2: 310.74
  })), _line235 || (_line235 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 851.15,
    y1: 308.22,
    x2: 851.15,
    y2: 310.74
  })), _line236 || (_line236 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 853,
    y1: 300.66,
    x2: 853,
    y2: 306.2
  })), _line237 || (_line237 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 850.12,
    y1: 306.2,
    x2: 850.12,
    y2: 315.58
  })), _line238 || (_line238 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 850.12,
    y1: 315.58,
    x2: 844.77,
    y2: 315.58
  })), _line239 || (_line239 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 844.26,
    y1: 306.2,
    x2: 853,
    y2: 306.2
  })), _line240 || (_line240 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 844.77,
    y1: 310.74,
    x2: 823.49,
    y2: 310.74
  })), _line241 || (_line241 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 850.94,
    y1: 308.02,
    x2: 851.15,
    y2: 308.02
  })), _line242 || (_line242 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 844.77,
    y1: 306.2,
    x2: 844.77,
    y2: 315.58
  })), _line243 || (_line243 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 852.69,
    y1: 308.02,
    x2: 852.69,
    y2: 306.2
  })), _line244 || (_line244 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 850.94,
    y1: 308.02,
    x2: 850.94,
    y2: 306.2
  })), _line245 || (_line245 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 850.94,
    y1: 308.22,
    x2: 852.69,
    y2: 308.22
  })), _line246 || (_line246 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 852.69,
    y1: 308.22,
    x2: 852.69,
    y2: 308.02
  })), _line247 || (_line247 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 850.94,
    y1: 308.22,
    x2: 850.94,
    y2: 308.02
  })), _line248 || (_line248 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 834.28,
    y1: 299.65,
    x2: 834.28,
    y2: 309.03
  })), _line249 || (_line249 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 844.26,
    y1: 299.65,
    x2: 844.26,
    y2: 309.03
  })), _line250 || (_line250 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 834.28,
    y1: 309.03,
    x2: 844.26,
    y2: 309.03
  })), _line251 || (_line251 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 834.28,
    y1: 299.65,
    x2: 844.26,
    y2: 299.65
  })), _line252 || (_line252 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 822.66,
    y1: 302.47,
    x2: 822.66,
    y2: 306.2
  })), _line253 || (_line253 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 875.62,
    y1: 300.66,
    x2: 856.29,
    y2: 300.66
  })), _line254 || (_line254 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 875.62,
    y1: 313.76,
    x2: 856.29,
    y2: 313.76
  })), _line255 || (_line255 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 875.62,
    y1: 300.66,
    x2: 875.62,
    y2: 313.76
  })), _line256 || (_line256 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 856.29,
    y1: 300.66,
    x2: 856.29,
    y2: 301.67
  })), _line257 || (_line257 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 853,
    y1: 301.67,
    x2: 853,
    y2: 306.2
  })), _line258 || (_line258 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 856.29,
    y1: 306.2,
    x2: 856.29,
    y2: 313.76
  })), _line259 || (_line259 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 868.11,
    y1: 301.67,
    x2: 853,
    y2: 301.67
  })), _line260 || (_line260 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 868.11,
    y1: 306.2,
    x2: 853,
    y2: 306.2
  })), _line261 || (_line261 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 868.11,
    y1: 301.67,
    x2: 868.11,
    y2: 306.2
  })), _line262 || (_line262 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 814.23,
    y1: 306.2,
    x2: 814.23,
    y2: 318.8
  })), _line263 || (_line263 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 814.23,
    y1: 318.8,
    x2: 819.58,
    y2: 318.8
  })), _line264 || (_line264 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 819.37,
    y1: 306.2,
    x2: 819.37,
    y2: 318.8
  })), _line265 || (_line265 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 621.33,
    y1: 408.71,
    x2: 499.07,
    y2: 408.71
  })), _line266 || (_line266 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 621.33,
    y1: 381.2,
    x2: 499.07,
    y2: 381.2
  })), _line267 || (_line267 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 499.07,
    y1: 408.71,
    x2: 499.07,
    y2: 381.2
  })), _line268 || (_line268 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 499.07,
    y1: 405.89,
    x2: 475.11,
    y2: 405.89
  })), _line269 || (_line269 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 499.07,
    y1: 383.72,
    x2: 475.11,
    y2: 383.72
  })), _line270 || (_line270 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 503.18,
    y1: 402.36,
    x2: 503.18,
    y2: 387.44
  })), _line271 || (_line271 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 621.33,
    y1: 381.2,
    x2: 621.33,
    y2: 408.71
  })), _line272 || (_line272 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 651.05,
    y1: 405.89,
    x2: 643.44,
    y2: 405.89
  })), _line273 || (_line273 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 651.05,
    y1: 383.72,
    x2: 643.44,
    y2: 383.72
  })), _line274 || (_line274 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 651.05,
    y1: 405.89,
    x2: 651.05,
    y2: 383.72
  })), _line275 || (_line275 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 635.93,
    y1: 380.69,
    x2: 635.93,
    y2: 382.91
  })), _line276 || (_line276 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 632.33,
    y1: 380.69,
    x2: 632.33,
    y2: 382.91
  })), _line277 || (_line277 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 643.44,
    y1: 382.91,
    x2: 621.85,
    y2: 382.91
  })), _line278 || (_line278 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 643.44,
    y1: 406.9,
    x2: 621.85,
    y2: 406.9
  })), _line279 || (_line279 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 643.44,
    y1: 406.9,
    x2: 643.44,
    y2: 382.91
  })), _line280 || (_line280 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 621.85,
    y1: 406.9,
    x2: 621.85,
    y2: 382.91
  })), _line281 || (_line281 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 481.8,
    y1: 433.41,
    x2: 481.8,
    y2: 438.95
  })), _line282 || (_line282 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 470.79,
    y1: 438.95,
    x2: 489.82,
    y2: 438.95
  })), _line283 || (_line283 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 502.67,
    y1: 433.41,
    x2: 481.8,
    y2: 433.41
  })), _line284 || (_line284 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 470.79,
    y1: 477.35,
    x2: 489.82,
    y2: 477.35
  })), _line285 || (_line285 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 487.97,
    y1: 375.35,
    x2: 485.7,
    y2: 375.35
  })), _line286 || (_line286 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 493.11,
    y1: 370.61,
    x2: 485.7,
    y2: 370.61
  })), _line287 || (_line287 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 475.11,
    y1: 405.89,
    x2: 475.11,
    y2: 383.72
  })), _line288 || (_line288 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 485.7,
    y1: 376.36,
    x2: 499.07,
    y2: 376.36
  })), _line289 || (_line289 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 499.07,
    y1: 383.72,
    x2: 499.07,
    y2: 376.36
  })), _line290 || (_line290 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 485.7,
    y1: 378.68,
    x2: 485.7,
    y2: 383.72
  })), _line291 || (_line291 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 485.7,
    y1: 383.72,
    x2: 485.7,
    y2: 376.36
  })), _line292 || (_line292 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 487.97,
    y1: 405.89,
    x2: 487.97,
    y2: 410.93
  })), _line293 || (_line293 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 490.54,
    y1: 405.89,
    x2: 490.54,
    y2: 410.93
  })), _line294 || (_line294 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 470.79,
    y1: 410.93,
    x2: 494.96,
    y2: 410.93
  })), _line295 || (_line295 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 470.79,
    y1: 432.9,
    x2: 470.79,
    y2: 410.93
  })), _line296 || (_line296 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 470.79,
    y1: 432.9,
    x2: 494.96,
    y2: 432.9
  })), _line297 || (_line297 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 494.96,
    y1: 410.93,
    x2: 494.96,
    y2: 432.9
  })), _line298 || (_line298 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 490.54,
    y1: 375.35,
    x2: 490.54,
    y2: 376.36
  })), _line299 || (_line299 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 487.97,
    y1: 375.35,
    x2: 487.97,
    y2: 376.36
  })), _line300 || (_line300 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 485.7,
    y1: 383.72,
    x2: 485.7,
    y2: 376.36
  })), _line301 || (_line301 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 485.7,
    y1: 370.61,
    x2: 485.7,
    y2: 375.35
  })), _line302 || (_line302 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 493.11,
    y1: 370.61,
    x2: 493.11,
    y2: 375.35
  })), _line303 || (_line303 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 493.11,
    y1: 375.35,
    x2: 487.97,
    y2: 375.35
  })), _line304 || (_line304 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 470.79,
    y1: 438.95,
    x2: 470.79,
    y2: 477.35
  })), _line305 || (_line305 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 502.67,
    y1: 433.41,
    x2: 502.67,
    y2: 435.93
  })), _line306 || (_line306 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 742.77,
    y1: 493.48,
    x2: 578.66,
    y2: 493.48
  })), _line307 || (_line307 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 729.71,
    y1: 372.83,
    x2: 729.71,
    y2: 435.93
  })), _line308 || (_line308 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 503.18,
    y1: 435.93,
    x2: 503.18,
    y2: 355.39
  })), _line309 || (_line309 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 742.77,
    y1: 493.48,
    x2: 742.77,
    y2: 435.93
  })), _line310 || (_line310 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 742.77,
    y1: 435.93,
    x2: 489.82,
    y2: 435.93
  })), _line311 || (_line311 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 489.82,
    y1: 435.93,
    x2: 489.82,
    y2: 493.48
  })), _line312 || (_line312 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 742.77,
    y1: 441.27,
    x2: 745.13,
    y2: 441.27
  })), _line313 || (_line313 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 745.13,
    y1: 466.47,
    x2: 745.13,
    y2: 468.28
  })), _line314 || (_line314 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 745.13,
    y1: 441.27,
    x2: 745.13,
    y2: 449.84
  })), _line315 || (_line315 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 750.27,
    y1: 449.84,
    x2: 745.13,
    y2: 449.84
  })), _line316 || (_line316 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 750.27,
    y1: 449.84,
    x2: 750.27,
    y2: 466.47
  })), _line317 || (_line317 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 750.27,
    y1: 466.47,
    x2: 745.13,
    y2: 466.47
  })), _line318 || (_line318 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 737.42,
    y1: 439.46,
    x2: 744.31,
    y2: 439.46
  })), _line319 || (_line319 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 744.31,
    y1: 434.72,
    x2: 744.31,
    y2: 439.46
  })), _line320 || (_line320 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 737.42,
    y1: 434.72,
    x2: 737.42,
    y2: 439.46
  })), _line321 || (_line321 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 737.42,
    y1: 434.72,
    x2: 744.31,
    y2: 434.72
  })), _line322 || (_line322 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 756.96,
    y1: 478.36,
    x2: 742.77,
    y2: 478.36
  })), _line323 || (_line323 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 756.96,
    y1: 478.36,
    x2: 756.96,
    y2: 468.28
  })), _line324 || (_line324 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 742.77,
    y1: 468.28,
    x2: 764.88,
    y2: 468.28
  })), _line325 || (_line325 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 755.42,
    y1: 463.95,
    x2: 764.88,
    y2: 463.95
  })), _line326 || (_line326 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 755.42,
    y1: 463.95,
    x2: 755.42,
    y2: 468.28
  })), _line327 || (_line327 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 764.88,
    y1: 463.95,
    x2: 764.88,
    y2: 471.81
  })), _line328 || (_line328 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 765.39,
    y1: 475.84,
    x2: 765.39,
    y2: 471.81
  })), _line329 || (_line329 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 756.96,
    y1: 475.84,
    x2: 765.39,
    y2: 475.84
  })), _line330 || (_line330 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 756.96,
    y1: 471.81,
    x2: 765.39,
    y2: 471.81
  })), _line331 || (_line331 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 800.56,
    y1: 471.81,
    x2: 815.77,
    y2: 471.81
  })), _line332 || (_line332 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 800.56,
    y1: 475.84,
    x2: 815.77,
    y2: 475.84
  })), _line333 || (_line333 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 815.77,
    y1: 475.84,
    x2: 815.77,
    y2: 471.81
  })), _line334 || (_line334 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 821.43,
    y1: 482.39,
    x2: 837.37,
    y2: 482.39
  })), _line335 || (_line335 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 821.43,
    y1: 482.39,
    x2: 821.43,
    y2: 465.76
  })), _line336 || (_line336 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 837.37,
    y1: 465.76,
    x2: 837.37,
    y2: 482.39
  })), _line337 || (_line337 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 821.43,
    y1: 465.76,
    x2: 837.37,
    y2: 465.76
  })), _line338 || (_line338 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 816.8,
    y1: 477.56,
    x2: 816.8,
    y2: 470.5
  })), _line339 || (_line339 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 816.8,
    y1: 477.56,
    x2: 821.43,
    y2: 477.56
  })), _line340 || (_line340 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 816.8,
    y1: 470.5,
    x2: 821.43,
    y2: 470.5
  })), _line341 || (_line341 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 821.12,
    y1: 464.76,
    x2: 821.12,
    y2: 470.5
  })), _line342 || (_line342 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 818.86,
    y1: 464.76,
    x2: 818.86,
    y2: 470.5
  })), _line343 || (_line343 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 821.94,
    y1: 508.4,
    x2: 821.94,
    y2: 501.04
  })), _line344 || (_line344 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 821.94,
    y1: 508.4,
    x2: 850.12,
    y2: 508.4
  })), _line345 || (_line345 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 850.12,
    y1: 508.4,
    x2: 850.12,
    y2: 501.04
  })), _line346 || (_line346 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 821.94,
    y1: 501.04,
    x2: 850.12,
    y2: 501.04
  })), _line347 || (_line347 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 840.66,
    y1: 438.75,
    x2: 818.35,
    y2: 438.75
  })), _line348 || (_line348 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 818.35,
    y1: 438.75,
    x2: 818.35,
    y2: 447.02
  })), _line349 || (_line349 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 840.66,
    y1: 447.02,
    x2: 840.66,
    y2: 438.75
  })), _line350 || (_line350 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 818.35,
    y1: 447.02,
    x2: 840.66,
    y2: 447.02
  })), _line351 || (_line351 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 851.97,
    y1: 449.03,
    x2: 851.97,
    y2: 437.94
  })), _line352 || (_line352 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 851.97,
    y1: 437.94,
    x2: 863.28,
    y2: 437.94
  })), _line353 || (_line353 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 863.28,
    y1: 437.94,
    x2: 863.28,
    y2: 449.03
  })), _line354 || (_line354 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 851.97,
    y1: 449.03,
    x2: 863.28,
    y2: 449.03
  })), _line355 || (_line355 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 837.37,
    y1: 471.81,
    x2: 857.62,
    y2: 471.81
  })), _line356 || (_line356 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 837.37,
    y1: 475.84,
    x2: 857.62,
    y2: 475.84
  })), _line357 || (_line357 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 893.1,
    y1: 432.7,
    x2: 893.1,
    y2: 451.35
  })), _line358 || (_line358 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 893.1,
    y1: 432.7,
    x2: 929.5,
    y2: 432.7
  })), _line359 || (_line359 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 929.5,
    y1: 451.35,
    x2: 929.5,
    y2: 444.5
  })), _line360 || (_line360 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 893.1,
    y1: 451.35,
    x2: 929.5,
    y2: 451.35
  })), _line361 || (_line361 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 952.94,
    y1: 451.05,
    x2: 952.94,
    y2: 441.98
  })), _line362 || (_line362 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 954.18,
    y1: 441.98,
    x2: 954.18,
    y2: 451.05
  })), _line363 || (_line363 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 932.89,
    y1: 451.05,
    x2: 932.89,
    y2: 445.5
  })), _line364 || (_line364 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 932.89,
    y1: 445.5,
    x2: 933.92,
    y2: 445.5
  })), _line365 || (_line365 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 933.92,
    y1: 445.5,
    x2: 933.92,
    y2: 450.34
  })), _line366 || (_line366 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 933.92,
    y1: 450.34,
    x2: 952.94,
    y2: 450.34
  })), _line367 || (_line367 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 954.18,
    y1: 451.05,
    x2: 932.89,
    y2: 451.05
  })), _line368 || (_line368 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 954.18,
    y1: 441.98,
    x2: 952.94,
    y2: 441.98
  })), _line369 || (_line369 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 869.66,
    y1: 476.85,
    x2: 869.66,
    y2: 467.28
  })), _line370 || (_line370 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 892.28,
    y1: 467.28,
    x2: 869.66,
    y2: 467.28
  })), _line371 || (_line371 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 872.53,
    y1: 460.72,
    x2: 885.9,
    y2: 460.72
  })), _line372 || (_line372 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 875.62,
    y1: 476.85,
    x2: 869.66,
    y2: 476.85
  })), _line373 || (_line373 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 881.48,
    y1: 475.84,
    x2: 883.54,
    y2: 475.84
  })), _line374 || (_line374 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 892.28,
    y1: 467.28,
    x2: 892.28,
    y2: 475.84
  })), _line375 || (_line375 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 872.53,
    y1: 460.72,
    x2: 872.53,
    y2: 467.28
  })), _line376 || (_line376 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 869.66,
    y1: 471.81,
    x2: 892.28,
    y2: 471.81
  })), _line377 || (_line377 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 869.66,
    y1: 475.84,
    x2: 881.48,
    y2: 475.84
  })), _line378 || (_line378 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 881.48,
    y1: 475.84,
    x2: 881.48,
    y2: 478.06
  })), _line379 || (_line379 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 875.62,
    y1: 478.06,
    x2: 881.48,
    y2: 478.06
  })), _line380 || (_line380 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 875.62,
    y1: 476.85,
    x2: 875.62,
    y2: 478.06
  })), _line381 || (_line381 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 891.25,
    y1: 475.84,
    x2: 891.76,
    y2: 475.84
  })), _line382 || (_line382 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 892.28,
    y1: 472.32,
    x2: 892.28,
    y2: 470
  })), _line383 || (_line383 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 883.54,
    y1: 475.84,
    x2: 884.05,
    y2: 475.84
  })), _line384 || (_line384 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 883.54,
    y1: 478.36,
    x2: 891.25,
    y2: 478.36
  })), _line385 || (_line385 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 891.25,
    y1: 475.84,
    x2: 891.25,
    y2: 478.36
  })), _line386 || (_line386 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 883.54,
    y1: 475.84,
    x2: 883.54,
    y2: 478.36
  })), _line387 || (_line387 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 884.05,
    y1: 475.84,
    x2: 891.25,
    y2: 475.84
  })), _line388 || (_line388 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 885.9,
    y1: 460.72,
    x2: 885.9,
    y2: 467.28
  })), _line389 || (_line389 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 894.85,
    y1: 475.84,
    x2: 892.28,
    y2: 475.84
  })), _line390 || (_line390 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 892.28,
    y1: 471.81,
    x2: 892.28,
    y2: 475.84
  })), _line391 || (_line391 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 900.81,
    y1: 471.81,
    x2: 892.28,
    y2: 471.81
  })), _line392 || (_line392 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 892.28,
    y1: 471.81,
    x2: 892.28,
    y2: 472.52
  })), _line393 || (_line393 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 900.81,
    y1: 475.84,
    x2: 899.99,
    y2: 475.84
  })), _line394 || (_line394 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 902.04,
    y1: 471.81,
    x2: 902.04,
    y2: 476.35
  })), _line395 || (_line395 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 900.81,
    y1: 471.81,
    x2: 900.81,
    y2: 476.35
  })), _line396 || (_line396 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 900.81,
    y1: 476.35,
    x2: 902.04,
    y2: 476.35
  })), _line397 || (_line397 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 894.85,
    y1: 485.12,
    x2: 899.99,
    y2: 485.12
  })), _line398 || (_line398 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 894.85,
    y1: 475.84,
    x2: 894.85,
    y2: 485.12
  })), _line399 || (_line399 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 899.99,
    y1: 475.84,
    x2: 899.99,
    y2: 485.12
  })), _line400 || (_line400 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 892.79,
    y1: 471.51,
    x2: 900.5,
    y2: 471.51
  })), _line401 || (_line401 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 900.5,
    y1: 471.51,
    x2: 900.5,
    y2: 476.85
  })), _line402 || (_line402 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 892.79,
    y1: 476.85,
    x2: 892.79,
    y2: 471.51
  })), _line403 || (_line403 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 900.5,
    y1: 476.85,
    x2: 892.79,
    y2: 476.85
  })), _line404 || (_line404 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 902.04,
    y1: 475.84,
    x2: 903.07,
    y2: 475.84
  })), _line405 || (_line405 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 902.04,
    y1: 471.81,
    x2: 903.07,
    y2: 471.81
  })), _line406 || (_line406 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 964.46,
    y1: 470,
    x2: 966.31,
    y2: 468.28
  })), _line407 || (_line407 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 964.46,
    y1: 477.35,
    x2: 965.28,
    y2: 477.35
  })), _line408 || (_line408 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 968.37,
    y1: 468.28,
    x2: 973.41,
    y2: 468.28
  })), _line409 || (_line409 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 973.41,
    y1: 468.79,
    x2: 973.41,
    y2: 468.28
  })), _line410 || (_line410 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 964.46,
    y1: 477.35,
    x2: 964.46,
    y2: 470
  })), _line411 || (_line411 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 966.31,
    y1: 468.28,
    x2: 968.37,
    y2: 468.28
  })), _polyline31 || (_polyline31 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "965.28 477.35 970.94 474.83 973.41 468.79"
  })), _line412 || (_line412 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 942.35,
    y1: 475.84,
    x2: 942.35,
    y2: 471.81
  })), _line413 || (_line413 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 940.81,
    y1: 471.81,
    x2: 963.74,
    y2: 471.81
  })), _line414 || (_line414 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 940.81,
    y1: 475.84,
    x2: 963.74,
    y2: 475.84
  })), _line415 || (_line415 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 964.46,
    y1: 475.84,
    x2: 963.74,
    y2: 475.84
  })), _line416 || (_line416 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 963.74,
    y1: 475.84,
    x2: 963.74,
    y2: 471.81
  })), _line417 || (_line417 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 964.46,
    y1: 472.32,
    x2: 963.74,
    y2: 472.32
  })), _line418 || (_line418 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 964.46,
    y1: 475.84,
    x2: 964.46,
    y2: 472.32
  })), _line419 || (_line419 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 968.37,
    y1: 413.25,
    x2: 968.37,
    y2: 407.4
  })), _line420 || (_line420 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 968.37,
    y1: 441.27,
    x2: 968.37,
    y2: 413.25
  })), _line421 || (_line421 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 972.17,
    y1: 441.27,
    x2: 972.17,
    y2: 413.25
  })), _line422 || (_line422 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 972.17,
    y1: 413.25,
    x2: 968.37,
    y2: 413.25
  })), _line423 || (_line423 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 635.93,
    y1: 364.77,
    x2: 635.93,
    y2: 380.69
  })), _line424 || (_line424 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 632.33,
    y1: 380.69,
    x2: 632.33,
    y2: 364.77
  })), _line425 || (_line425 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 719.63,
    y1: 297.43,
    x2: 719.63,
    y2: 311.75
  })), _line426 || (_line426 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 706.57,
    y1: 320.11,
    x2: 675.01,
    y2: 320.11
  })), _line427 || (_line427 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 706.57,
    y1: 320.11,
    x2: 706.57,
    y2: 311.75
  })), _line428 || (_line428 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 648.48,
    y1: 297.43,
    x2: 648.48,
    y2: 311.75
  })), _line429 || (_line429 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 674.49,
    y1: 311.75,
    x2: 648.48,
    y2: 311.75
  })), _line430 || (_line430 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 719.63,
    y1: 297.43,
    x2: 648.48,
    y2: 297.43
  })), _line431 || (_line431 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 675.01,
    y1: 320.11,
    x2: 675.01,
    y2: 297.43
  })), _line432 || (_line432 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 674.49,
    y1: 297.43,
    x2: 674.49,
    y2: 311.75
  })), _line433 || (_line433 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 706.57,
    y1: 311.75,
    x2: 719.63,
    y2: 311.75
  })), _line434 || (_line434 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 654.44,
    y1: 318.3,
    x2: 665.44,
    y2: 318.3
  })), _line435 || (_line435 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 665.44,
    y1: 318.3,
    x2: 665.44,
    y2: 313.76
  })), _line436 || (_line436 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 665.44,
    y1: 313.76,
    x2: 654.44,
    y2: 313.76
  })), _line437 || (_line437 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 654.44,
    y1: 313.76,
    x2: 654.44,
    y2: 318.3
  })), _line438 || (_line438 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 635.93,
    y1: 346.12,
    x2: 635.93,
    y2: 364.77
  })), _line439 || (_line439 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 632.33,
    y1: 346.12,
    x2: 632.33,
    y2: 364.77
  })), _line440 || (_line440 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 674.18,
    y1: 343.3,
    x2: 635.93,
    y2: 343.3
  })), _line441 || (_line441 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 674.18,
    y1: 339.57,
    x2: 635.93,
    y2: 339.57
  })), _line442 || (_line442 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 635.93,
    y1: 380.69,
    x2: 632.33,
    y2: 380.69
  })), _line443 || (_line443 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 635.93,
    y1: 346.12,
    x2: 632.33,
    y2: 346.12
  })), _line444 || (_line444 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 635.93,
    y1: 301.16,
    x2: 635.93,
    y2: 346.12
  })), _line445 || (_line445 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 632.33,
    y1: 301.16,
    x2: 632.33,
    y2: 346.12
  })), _line446 || (_line446 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 711.92,
    y1: 343.3,
    x2: 674.18,
    y2: 343.3
  })), _line447 || (_line447 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 711.92,
    y1: 339.57,
    x2: 674.18,
    y2: 339.57
  })), _line448 || (_line448 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 674.18,
    y1: 339.57,
    x2: 674.18,
    y2: 343.3
  })), _line449 || (_line449 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 749.97,
    y1: 343.3,
    x2: 711.92,
    y2: 343.3
  })), _line450 || (_line450 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 749.97,
    y1: 339.57,
    x2: 711.92,
    y2: 339.57
  })), _line451 || (_line451 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 711.92,
    y1: 339.57,
    x2: 711.92,
    y2: 343.3
  })), _line452 || (_line452 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 771.35,
    y1: 395.11,
    x2: 767.45,
    y2: 395.11
  })), _line453 || (_line453 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 767.45,
    y1: 395.11,
    x2: 767.45,
    y2: 401.35
  })), _line454 || (_line454 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 774.13,
    y1: 407.71,
    x2: 766.42,
    y2: 407.71
  })), _line455 || (_line455 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 774.13,
    y1: 401.35,
    x2: 766.42,
    y2: 401.35
  })), _line456 || (_line456 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 774.13,
    y1: 401.35,
    x2: 774.13,
    y2: 407.71
  })), _line457 || (_line457 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 766.42,
    y1: 401.35,
    x2: 766.42,
    y2: 407.71
  })), _line458 || (_line458 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 771.35,
    y1: 395.11,
    x2: 771.35,
    y2: 401.35
  })), _line459 || (_line459 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 783.59,
    y1: 406.39,
    x2: 774.13,
    y2: 406.39
  })), _line460 || (_line460 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 783.59,
    y1: 402.36,
    x2: 774.13,
    y2: 402.36
  })), _line461 || (_line461 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 877.37,
    y1: 398.13,
    x2: 877.37,
    y2: 411.94
  })), _line462 || (_line462 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 813.41,
    y1: 411.94,
    x2: 800.86,
    y2: 411.94
  })), _line463 || (_line463 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 864.51,
    y1: 420,
    x2: 864.51,
    y2: 398.13
  })), _line464 || (_line464 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 877.37,
    y1: 411.94,
    x2: 864.51,
    y2: 411.94
  })), _line465 || (_line465 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 813.41,
    y1: 420,
    x2: 813.41,
    y2: 411.94
  })), _line466 || (_line466 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 904.1,
    y1: 402.67,
    x2: 877.37,
    y2: 402.36
  })), _line467 || (_line467 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 904.92,
    y1: 406.39,
    x2: 877.37,
    y2: 406.39
  })), _line468 || (_line468 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 866.36,
    y1: 398.13,
    x2: 877.37,
    y2: 398.13
  })), _line469 || (_line469 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 813.41,
    y1: 398.13,
    x2: 813.41,
    y2: 420
  })), _line470 || (_line470 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 794.69,
    y1: 396.62,
    x2: 783.59,
    y2: 396.62
  })), _line471 || (_line471 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 800.86,
    y1: 411.94,
    x2: 813.41,
    y2: 411.94
  })), _line472 || (_line472 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 800.86,
    y1: 398.33,
    x2: 813.41,
    y2: 398.33
  })), _line473 || (_line473 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 783.59,
    y1: 412.74,
    x2: 800.86,
    y2: 412.74
  })), _line474 || (_line474 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 783.59,
    y1: 412.74,
    x2: 783.59,
    y2: 396.62
  })), _line475 || (_line475 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 800.86,
    y1: 412.74,
    x2: 800.86,
    y2: 396.62
  })), _line476 || (_line476 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 783.59,
    y1: 396.62,
    x2: 800.86,
    y2: 396.62
  })), _line477 || (_line477 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 865.34,
    y1: 398.13,
    x2: 877.37,
    y2: 398.13
  })), _line478 || (_line478 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 865.34,
    y1: 411.94,
    x2: 877.37,
    y2: 411.94
  })), _line479 || (_line479 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 813.41,
    y1: 398.13,
    x2: 838.09,
    y2: 398.13
  })), _line480 || (_line480 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 813.41,
    y1: 420,
    x2: 838.09,
    y2: 420
  })), _line481 || (_line481 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 864.51,
    y1: 420,
    x2: 864.51,
    y2: 398.13
  })), _line482 || (_line482 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 813.41,
    y1: 420,
    x2: 864.51,
    y2: 420
  })), _line483 || (_line483 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 813.41,
    y1: 398.13,
    x2: 865.34,
    y2: 398.13
  })), _line484 || (_line484 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 972.17,
    y1: 403.37,
    x2: 949.55,
    y2: 403.37
  })), _line485 || (_line485 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 968.37,
    y1: 407.4,
    x2: 949.55,
    y2: 407.4
  })), _line486 || (_line486 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 956.03,
    y1: 416.98,
    x2: 941.63,
    y2: 416.98
  })), _line487 || (_line487 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 941.63,
    y1: 416.98,
    x2: 941.63,
    y2: 401.35
  })), _line488 || (_line488 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 955.21,
    y1: 403.37,
    x2: 955.51,
    y2: 403.37
  })), _line489 || (_line489 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 946.98,
    y1: 396.82,
    x2: 956.03,
    y2: 396.82
  })), _line490 || (_line490 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 956.03,
    y1: 416.98,
    x2: 956.03,
    y2: 396.82
  })), _line491 || (_line491 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 946.98,
    y1: 396.82,
    x2: 946.98,
    y2: 398.13
  })), _line492 || (_line492 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 939.27,
    y1: 398.13,
    x2: 946.98,
    y2: 398.13
  })), _line493 || (_line493 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 939.27,
    y1: 398.13,
    x2: 939.27,
    y2: 401.35
  })), _line494 || (_line494 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 949.55,
    y1: 407.4,
    x2: 925.39,
    y2: 407.4
  })), _line495 || (_line495 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 949.55,
    y1: 403.37,
    x2: 926.21,
    y2: 403.37
  })), _line496 || (_line496 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 925.39,
    y1: 403.37,
    x2: 926.21,
    y2: 403.37
  })), _line497 || (_line497 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 925.39,
    y1: 403.37,
    x2: 925.9,
    y2: 403.37
  })), _line498 || (_line498 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 925.39,
    y1: 407.4,
    x2: 925.39,
    y2: 403.37
  })), _line499 || (_line499 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 925.39,
    y1: 408.21,
    x2: 904.92,
    y2: 408.21
  })), _line500 || (_line500 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 904.1,
    y1: 402.67,
    x2: 925.39,
    y2: 402.67
  })), _line501 || (_line501 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 925.39,
    y1: 402.67,
    x2: 925.39,
    y2: 408.21
  })), _line502 || (_line502 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 904.92,
    y1: 408.21,
    x2: 904.92,
    y2: 402.67
  })), _line503 || (_line503 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 994.28,
    y1: 441.47,
    x2: 1012.48,
    y2: 441.47
  })), _line504 || (_line504 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1012.79,
    y1: 446.51,
    x2: 1012.79,
    y2: 441.47
  })), _line505 || (_line505 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1012.79,
    y1: 446.51,
    x2: 1013.3,
    y2: 446.51
  })), _line506 || (_line506 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1013.3,
    y1: 451.35,
    x2: 1013.3,
    y2: 446.51
  })), _line507 || (_line507 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1012.27,
    y1: 451.35,
    x2: 1013.3,
    y2: 451.35
  })), _line508 || (_line508 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 966.31,
    y1: 456.39,
    x2: 1012.27,
    y2: 456.39
  })), _line509 || (_line509 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1012.27,
    y1: 456.39,
    x2: 1012.27,
    y2: 451.35
  })), _line510 || (_line510 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 966.31,
    y1: 441.47,
    x2: 993.77,
    y2: 441.47
  })), _line511 || (_line511 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 994.28,
    y1: 441.47,
    x2: 993.77,
    y2: 441.47
  })), _line512 || (_line512 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1012.79,
    y1: 441.47,
    x2: 1012.48,
    y2: 441.47
  })), _line513 || (_line513 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 966.31,
    y1: 441.47,
    x2: 966.31,
    y2: 456.39
  })), _line514 || (_line514 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 972.17,
    y1: 468.28,
    x2: 972.17,
    y2: 467.48
  })), _line515 || (_line515 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 972.17,
    y1: 467.48,
    x2: 968.37,
    y2: 467.48
  })), _line516 || (_line516 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 968.37,
    y1: 468.28,
    x2: 968.37,
    y2: 467.48
  })), _line517 || (_line517 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 972.17,
    y1: 468.28,
    x2: 968.37,
    y2: 468.28
  })), _line518 || (_line518 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 968.37,
    y1: 467.48,
    x2: 968.37,
    y2: 441.27
  })), _line519 || (_line519 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 972.17,
    y1: 467.48,
    x2: 972.17,
    y2: 441.27
  })), _line520 || (_line520 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 972.17,
    y1: 441.27,
    x2: 968.37,
    y2: 441.27
  })), _line521 || (_line521 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 780.81,
    y1: 302.47,
    x2: 755.42,
    y2: 302.47
  })), _line522 || (_line522 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 780.81,
    y1: 306.2,
    x2: 755.42,
    y2: 306.2
  })), _line523 || (_line523 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 780.81,
    y1: 302.47,
    x2: 780.81,
    y2: 306.2
  })), _line524 || (_line524 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 755.42,
    y1: 302.47,
    x2: 755.42,
    y2: 306.2
  })), _line525 || (_line525 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 767.24,
    y1: 348.84,
    x2: 767.24,
    y2: 343.3
  })), _line526 || (_line526 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 767.24,
    y1: 339.57,
    x2: 767.24,
    y2: 306.51
  })), _line527 || (_line527 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 771.35,
    y1: 348.84,
    x2: 771.35,
    y2: 306.51
  })), _line528 || (_line528 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 771.35,
    y1: 395.11,
    x2: 771.35,
    y2: 394.3
  })), _line529 || (_line529 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 771.35,
    y1: 394.3,
    x2: 767.24,
    y2: 394.3
  })), _line530 || (_line530 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 767.45,
    y1: 395.11,
    x2: 767.45,
    y2: 394.3
  })), _line531 || (_line531 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 771.35,
    y1: 395.11,
    x2: 767.45,
    y2: 395.11
  })), _line532 || (_line532 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 767.24,
    y1: 394.3,
    x2: 767.24,
    y2: 348.84
  })), _line533 || (_line533 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 771.35,
    y1: 394.3,
    x2: 771.35,
    y2: 348.84
  })), _line534 || (_line534 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 771.35,
    y1: 348.84,
    x2: 767.24,
    y2: 348.84
  })), _line535 || (_line535 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 771.35,
    y1: 395.11,
    x2: 769.3,
    y2: 395.11
  })), _line536 || (_line536 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 767.24,
    y1: 343.3,
    x2: 749.97,
    y2: 343.3
  })), _line537 || (_line537 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 767.24,
    y1: 339.57,
    x2: 749.97,
    y2: 339.57
  })), _line538 || (_line538 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 749.97,
    y1: 339.57,
    x2: 749.97,
    y2: 343.3
  })), _line539 || (_line539 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 732.28,
    y1: 339.57,
    x2: 732.28,
    y2: 343.3
  })), _line540 || (_line540 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 972.17,
    y1: 403.37,
    x2: 972.17,
    y2: 413.25
  })), _line541 || (_line541 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 487.25,
    y1: 350.35,
    x2: 487.25,
    y2: 347.63
  })), _line542 || (_line542 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 473.57,
    y1: 353.88,
    x2: 473.57,
    y2: 329.99
  })), _line543 || (_line543 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 486.94,
    y1: 353.88,
    x2: 473.57,
    y2: 353.88
  })), _line544 || (_line544 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 477.48,
    y1: 329.99,
    x2: 473.57,
    y2: 329.99
  })), _line545 || (_line545 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 487.25,
    y1: 298.64,
    x2: 479.53,
    y2: 298.64
  })), _line546 || (_line546 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 479.53,
    y1: 298.64,
    x2: 479.53,
    y2: 312.55
  })), _line547 || (_line547 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 487.25,
    y1: 298.64,
    x2: 487.25,
    y2: 353.88
  })), _line548 || (_line548 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 473.57,
    y1: 353.88,
    x2: 473.57,
    y2: 329.99
  })), _line549 || (_line549 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 486.94,
    y1: 353.88,
    x2: 473.57,
    y2: 353.88
  })), _line550 || (_line550 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 477.48,
    y1: 312.55,
    x2: 477.48,
    y2: 329.99
  })), _line551 || (_line551 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 477.48,
    y1: 329.99,
    x2: 473.57,
    y2: 329.99
  })), _line552 || (_line552 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 487.25,
    y1: 353.88,
    x2: 473.57,
    y2: 353.88
  })), _line553 || (_line553 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 477.48,
    y1: 329.99,
    x2: 473.57,
    y2: 329.99
  })), _line554 || (_line554 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 490.33,
    y1: 309.73,
    x2: 528.07,
    y2: 309.73
  })), _line555 || (_line555 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 490.33,
    y1: 338.76,
    x2: 528.07,
    y2: 338.76
  })), _line556 || (_line556 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 487.76,
    y1: 307.51,
    x2: 491.57,
    y2: 307.51
  })), _line557 || (_line557 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 651.05,
    y1: 332.01,
    x2: 611.77,
    y2: 332.01
  })), _line558 || (_line558 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 651.05,
    y1: 316.59,
    x2: 642.41,
    y2: 316.59
  })), _line559 || (_line559 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 651.05,
    y1: 332.01,
    x2: 651.05,
    y2: 316.59
  })), _line560 || (_line560 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 632.33,
    y1: 332.01,
    x2: 632.33,
    y2: 316.59
  })), _line561 || (_line561 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 529.61,
    y1: 313.76,
    x2: 529.61,
    y2: 335.03
  })), _line562 || (_line562 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 611.77,
    y1: 335.03,
    x2: 611.77,
    y2: 313.76
  })), _line563 || (_line563 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 529.61,
    y1: 313.76,
    x2: 611.77,
    y2: 313.76
  })), _line564 || (_line564 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 529.61,
    y1: 335.03,
    x2: 611.77,
    y2: 335.03
  })), _line565 || (_line565 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 624.62,
    y1: 314.77,
    x2: 611.77,
    y2: 314.77
  })), _line566 || (_line566 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 519.84,
    y1: 306.2,
    x2: 491.57,
    y2: 306.2
  })), _line567 || (_line567 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 519.84,
    y1: 283.02,
    x2: 491.57,
    y2: 283.02
  })), _line568 || (_line568 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 491.57,
    y1: 306.2,
    x2: 491.57,
    y2: 283.02
  })), _line569 || (_line569 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 519.84,
    y1: 306.2,
    x2: 519.84,
    y2: 283.02
  })), _line570 || (_line570 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 490.33,
    y1: 335.03,
    x2: 490.33,
    y2: 338.76
  })), _line571 || (_line571 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 527.55,
    y1: 333.72,
    x2: 527.55,
    y2: 338.76
  })), _line572 || (_line572 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 527.55,
    y1: 333.72,
    x2: 527.55,
    y2: 309.73
  })), _line573 || (_line573 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 490.33,
    y1: 335.03,
    x2: 490.33,
    y2: 309.73
  })), _line574 || (_line574 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 490.33,
    y1: 309.73,
    x2: 528.07,
    y2: 309.73
  })), _line575 || (_line575 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 528.07,
    y1: 333.72,
    x2: 528.07,
    y2: 338.76
  })), _line576 || (_line576 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 490.33,
    y1: 338.76,
    x2: 528.07,
    y2: 338.76
  })), _line577 || (_line577 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 490.33,
    y1: 335.03,
    x2: 490.33,
    y2: 338.76
  })), _line578 || (_line578 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 525.7,
    y1: 285.24,
    x2: 525.7,
    y2: 307.51
  })), _line579 || (_line579 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 519.84,
    y1: 307.51,
    x2: 519.84,
    y2: 285.24
  })), _line580 || (_line580 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 519.84,
    y1: 307.51,
    x2: 525.7,
    y2: 307.51
  })), _line581 || (_line581 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 525.7,
    y1: 285.24,
    x2: 519.84,
    y2: 285.24
  })), _line582 || (_line582 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 491.57,
    y1: 307.51,
    x2: 491.57,
    y2: 286.04
  })), _line583 || (_line583 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 487.76,
    y1: 286.04,
    x2: 487.76,
    y2: 307.51
  })), _line584 || (_line584 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 487.76,
    y1: 307.51,
    x2: 491.57,
    y2: 307.51
  })), _line585 || (_line585 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 487.76,
    y1: 286.04,
    x2: 491.57,
    y2: 286.04
  })), _line586 || (_line586 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 483.13,
    y1: 383.72,
    x2: 483.13,
    y2: 353.68
  })), _line587 || (_line587 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 480.05,
    y1: 383.72,
    x2: 480.05,
    y2: 353.68
  })), _line588 || (_line588 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 631.31,
    y1: 301.16,
    x2: 637.27,
    y2: 301.16
  })), _line589 || (_line589 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 637.27,
    y1: 301.16,
    x2: 637.27,
    y2: 296.63
  })), _line590 || (_line590 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 637.27,
    y1: 296.63,
    x2: 631.31,
    y2: 296.63
  })), _line591 || (_line591 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 631.31,
    y1: 296.63,
    x2: 631.31,
    y2: 301.16
  })), _line592 || (_line592 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 936.7,
    y1: 432.2,
    x2: 936.7,
    y2: 440.97
  })), _line593 || (_line593 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 936.7,
    y1: 440.97,
    x2: 956.75,
    y2: 440.97
  })), _line594 || (_line594 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 956.75,
    y1: 432.2,
    x2: 956.75,
    y2: 440.97
  })), _line595 || (_line595 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 956.75,
    y1: 439.46,
    x2: 958.08,
    y2: 439.46
  })), _line596 || (_line596 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 956.75,
    y1: 433.71,
    x2: 958.08,
    y2: 433.71
  })), _line597 || (_line597 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 936.7,
    y1: 432.2,
    x2: 956.75,
    y2: 432.2
  })), _line598 || (_line598 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 958.08,
    y1: 432.9,
    x2: 958.08,
    y2: 440.26
  })), _line599 || (_line599 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 958.08,
    y1: 432.9,
    x2: 958.6,
    y2: 432.9
  })), _line600 || (_line600 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 958.08,
    y1: 440.26,
    x2: 958.6,
    y2: 440.26
  })), _line601 || (_line601 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 958.08,
    y1: 432.9,
    x2: 958.08,
    y2: 440.26
  })), _line602 || (_line602 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 924.67,
    y1: 433.91,
    x2: 936.7,
    y2: 433.91
  })), _line603 || (_line603 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 929.5,
    y1: 438.95,
    x2: 936.7,
    y2: 438.95
  })), _line604 || (_line604 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 892.28,
    y1: 433.71,
    x2: 892.28,
    y2: 450.54
  })), _line605 || (_line605 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 881.99,
    y1: 439.46,
    x2: 892.28,
    y2: 433.71
  })), _line606 || (_line606 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 881.99,
    y1: 444.5,
    x2: 881.99,
    y2: 439.46
  })), _line607 || (_line607 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 892.28,
    y1: 450.54,
    x2: 881.99,
    y2: 444.5
  })), _line608 || (_line608 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 886.62,
    y1: 447.32,
    x2: 886.62,
    y2: 436.43
  })), _line609 || (_line609 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 893.1,
    y1: 441.98,
    x2: 880.97,
    y2: 441.98
  })), _line610 || (_line610 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 929.5,
    y1: 432.7,
    x2: 929.5,
    y2: 444.5
  })), _line611 || (_line611 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 815.98,
    y1: 447.82,
    x2: 806.73,
    y2: 447.82
  })), _line612 || (_line612 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 806.73,
    y1: 447.82,
    x2: 806.73,
    y2: 438.45
  })), _line613 || (_line613 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 806.73,
    y1: 438.45,
    x2: 815.98,
    y2: 438.45
  })), _line614 || (_line614 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 815.98,
    y1: 438.45,
    x2: 815.98,
    y2: 447.82
  })), _line615 || (_line615 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 734.54,
    y1: 301.47,
    x2: 734.85,
    y2: 301.47
  })), _line616 || (_line616 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 734.54,
    y1: 307.21,
    x2: 734.85,
    y2: 307.21
  })), _line617 || (_line617 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 719.63,
    y1: 307.21,
    x2: 734.54,
    y2: 307.21
  })), _line618 || (_line618 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 734.54,
    y1: 301.47,
    x2: 719.63,
    y2: 301.47
  })), _line619 || (_line619 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 734.54,
    y1: 301.47,
    x2: 734.54,
    y2: 307.21
  })), _line620 || (_line620 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 755.42,
    y1: 307.21,
    x2: 734.85,
    y2: 307.21
  })), _line621 || (_line621 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 734.85,
    y1: 307.21,
    x2: 734.85,
    y2: 301.47
  })), _line622 || (_line622 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 734.85,
    y1: 301.47,
    x2: 755.42,
    y2: 301.47
  })), _line623 || (_line623 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 755.42,
    y1: 301.47,
    x2: 755.42,
    y2: 307.21
  })), _line624 || (_line624 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 578.66,
    y1: 502.86,
    x2: 489.82,
    y2: 502.86
  })), _line625 || (_line625 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 742.77,
    y1: 493.48,
    x2: 578.66,
    y2: 493.48
  })), _line626 || (_line626 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 578.66,
    y1: 493.48,
    x2: 578.66,
    y2: 502.86
  })), _line627 || (_line627 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 489.82,
    y1: 435.93,
    x2: 489.82,
    y2: 502.86
  })), _line628 || (_line628 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 869.66,
    y1: 471.81,
    x2: 858.14,
    y2: 471.81
  })), _line629 || (_line629 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 858.14,
    y1: 475.84,
    x2: 858.65,
    y2: 475.84
  })), _line630 || (_line630 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 858.14,
    y1: 471.81,
    x2: 858.14,
    y2: 472.32
  })), _line631 || (_line631 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 858.14,
    y1: 475.84,
    x2: 858.14,
    y2: 472.32
  })), _line632 || (_line632 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 869.66,
    y1: 475.84,
    x2: 869.66,
    y2: 472.32
  })), _line633 || (_line633 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 869.66,
    y1: 475.84,
    x2: 858.14,
    y2: 475.84
  })), _line634 || (_line634 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 869.66,
    y1: 475.84,
    x2: 869.96,
    y2: 475.84
  })), _line635 || (_line635 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 869.66,
    y1: 472.32,
    x2: 869.66,
    y2: 471.81
  })), _line636 || (_line636 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 857.62,
    y1: 475.84,
    x2: 857.62,
    y2: 471.81
  })), _line637 || (_line637 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 745.85,
    y1: 414.26,
    x2: 730.74,
    y2: 414.26
  })), _line638 || (_line638 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 729.71,
    y1: 414.26,
    x2: 730.74,
    y2: 414.26
  })), _line639 || (_line639 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 745.85,
    y1: 373.64,
    x2: 729.71,
    y2: 373.64
  })), _line640 || (_line640 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 745.85,
    y1: 414.26,
    x2: 745.85,
    y2: 355.39
  })), _line641 || (_line641 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 745.85,
    y1: 355.39,
    x2: 503.18,
    y2: 355.39
  })), _line642 || (_line642 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 729.71,
    y1: 373.64,
    x2: 729.71,
    y2: 355.39
  })), _line643 || (_line643 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 781.84,
    y1: 302.47,
    x2: 791.82,
    y2: 302.47
  })), _line644 || (_line644 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 792.12,
    y1: 302.47,
    x2: 791.82,
    y2: 302.47
  })), _line645 || (_line645 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 792.12,
    y1: 302.47,
    x2: 792.33,
    y2: 302.47
  })), _line646 || (_line646 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 792.12,
    y1: 306.2,
    x2: 792.12,
    y2: 302.47
  })), _line647 || (_line647 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 792.12,
    y1: 306.2,
    x2: 792.33,
    y2: 306.2
  })), _line648 || (_line648 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 792.12,
    y1: 306.2,
    x2: 781.02,
    y2: 306.2
  })), _line649 || (_line649 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 781.02,
    y1: 302.47,
    x2: 781.02,
    y2: 306.2
  })), _line650 || (_line650 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 781.02,
    y1: 306.2,
    x2: 781.53,
    y2: 306.2
  })), _line651 || (_line651 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 781.02,
    y1: 302.47,
    x2: 781.53,
    y2: 302.47
  })), _line652 || (_line652 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 781.02,
    y1: 302.47,
    x2: 781.84,
    y2: 302.47
  })), _line653 || (_line653 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 781.84,
    y1: 306.2,
    x2: 781.84,
    y2: 308.72
  })), _line654 || (_line654 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 784.41,
    y1: 299.95,
    x2: 781.84,
    y2: 299.95
  })), _line655 || (_line655 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 781.84,
    y1: 308.72,
    x2: 784.41,
    y2: 308.72
  })), _line656 || (_line656 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 781.84,
    y1: 299.95,
    x2: 781.84,
    y2: 302.47
  })), _line657 || (_line657 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 784.41,
    y1: 306.2,
    x2: 784.41,
    y2: 308.72
  })), _line658 || (_line658 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 784.41,
    y1: 299.95,
    x2: 784.41,
    y2: 302.47
  })), _line659 || (_line659 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 940.81,
    y1: 471.81,
    x2: 940.81,
    y2: 475.84
  })), _line660 || (_line660 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 940.81,
    y1: 475.84,
    x2: 903.07,
    y2: 475.84
  })), _line661 || (_line661 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 940.81,
    y1: 471.81,
    x2: 903.07,
    y2: 471.81
  })), _line662 || (_line662 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 766.21,
    y1: 475.84,
    x2: 766.21,
    y2: 471.81
  })), _line663 || (_line663 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 766.21,
    y1: 471.81,
    x2: 800.56,
    y2: 471.81
  })), _line664 || (_line664 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 766.21,
    y1: 475.84,
    x2: 800.56,
    y2: 475.84
  })), _line665 || (_line665 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 800.56,
    y1: 475.84,
    x2: 800.56,
    y2: 471.81
  })), _line666 || (_line666 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 838.91,
    y1: 369.1,
    x2: 816.29,
    y2: 369.1
  })), _line667 || (_line667 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 816.29,
    y1: 369.1,
    x2: 816.29,
    y2: 354.38
  })), _line668 || (_line668 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 816.29,
    y1: 354.38,
    x2: 838.91,
    y2: 354.38
  })), _line669 || (_line669 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 838.91,
    y1: 354.38,
    x2: 838.91,
    y2: 369.1
  })), _line670 || (_line670 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 642.41,
    y1: 316.59,
    x2: 642.41,
    y2: 300.46
  })), _line671 || (_line671 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 642.41,
    y1: 300.46,
    x2: 624.62,
    y2: 300.46
  })), _line672 || (_line672 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 624.62,
    y1: 300.46,
    x2: 624.62,
    y2: 314.77
  })), _line673 || (_line673 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 941.63,
    y1: 401.35,
    x2: 939.27,
    y2: 401.35
  })), _line674 || (_line674 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 900.81,
    y1: 471.81,
    x2: 902.04,
    y2: 471.81
  })), _line675 || (_line675 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 479.53,
    y1: 312.55,
    x2: 477.48,
    y2: 312.55
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "821.12 464.76 820.92 463.95 820.09 463.75 819.37 463.95 818.86 464.76 819.37 465.46 820.09 465.46 820.92 465.46 821.12 464.76"
  })), _line676 || (_line676 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 891.25,
    y1: 475.84,
    x2: 892.28,
    y2: 475.84
  })), _line677 || (_line677 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 792.84,
    y1: 354.38,
    x2: 811.66,
    y2: 354.38
  })), _line678 || (_line678 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 811.66,
    y1: 359.73,
    x2: 811.66,
    y2: 354.69
  })), _line679 || (_line679 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 811.66,
    y1: 359.73,
    x2: 811.87,
    y2: 359.73
  })), _line680 || (_line680 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 811.87,
    y1: 364.56,
    x2: 811.87,
    y2: 359.73
  })), _line681 || (_line681 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 811.15,
    y1: 364.56,
    x2: 811.87,
    y2: 364.56
  })), _line682 || (_line682 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 765.39,
    y1: 369.6,
    x2: 811.15,
    y2: 369.6
  })), _line683 || (_line683 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 811.15,
    y1: 369.6,
    x2: 811.15,
    y2: 364.56
  })), _line684 || (_line684 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 765.39,
    y1: 354.69,
    x2: 792.84,
    y2: 354.69
  })), _line685 || (_line685 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 792.84,
    y1: 354.38,
    x2: 792.84,
    y2: 354.69
  })), _line686 || (_line686 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 811.66,
    y1: 354.69,
    x2: 811.66,
    y2: 354.38
  })), _line687 || (_line687 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 765.39,
    y1: 354.69,
    x2: 765.39,
    y2: 369.6
  })), _line688 || (_line688 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 648.48,
    y1: 306.71,
    x2: 642.41,
    y2: 306.71
  })), _line689 || (_line689 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 925.39,
    y1: 407.4,
    x2: 925.9,
    y2: 407.4
  })), _line690 || (_line690 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 648.48,
    y1: 302.98,
    x2: 642.41,
    y2: 302.98
  })), _line691 || (_line691 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 737.11,
    y1: 539.95,
    x2: 737.11,
    y2: 535.61
  })), _line692 || (_line692 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 750.27,
    y1: 539.95,
    x2: 750.27,
    y2: 535.61
  })), _line693 || (_line693 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 737.11,
    y1: 535.61,
    x2: 750.27,
    y2: 535.61
  })), _line694 || (_line694 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 737.11,
    y1: 539.95,
    x2: 750.27,
    y2: 539.95
  })), _line695 || (_line695 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 748.42,
    y1: 533.1,
    x2: 727.86,
    y2: 533.1
  })), _line696 || (_line696 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 727.86,
    y1: 545.49,
    x2: 748.42,
    y2: 545.49
  })), _line697 || (_line697 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 735.57,
    y1: 535.41,
    x2: 728.17,
    y2: 535.41
  })), _line698 || (_line698 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 735.57,
    y1: 529.57,
    x2: 735.57,
    y2: 535.41
  })), _line699 || (_line699 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 728.17,
    y1: 535.41,
    x2: 728.17,
    y2: 529.57
  })), _line700 || (_line700 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 735.57,
    y1: 529.57,
    x2: 728.17,
    y2: 529.57
  })), _line701 || (_line701 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 748.42,
    y1: 533.1,
    x2: 748.42,
    y2: 545.49
  })), _line702 || (_line702 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 727.86,
    y1: 533.1,
    x2: 727.86,
    y2: 545.49
  })), _line703 || (_line703 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 717.88,
    y1: 537.13,
    x2: 717.88,
    y2: 533.6
  })), _line704 || (_line704 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 699.17,
    y1: 533.6,
    x2: 699.68,
    y2: 533.6
  })), _line705 || (_line705 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 699.89,
    y1: 533.6,
    x2: 700.4,
    y2: 533.6
  })), _line706 || (_line706 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 699.89,
    y1: 533.6,
    x2: 700.4,
    y2: 533.6
  })), _line707 || (_line707 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 699.17,
    y1: 533.6,
    x2: 699.89,
    y2: 533.6
  })), _line708 || (_line708 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 698.86,
    y1: 546.2,
    x2: 698.86,
    y2: 533.6
  })), _line709 || (_line709 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 717.88,
    y1: 546.2,
    x2: 717.88,
    y2: 533.6
  })), _line710 || (_line710 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 717.88,
    y1: 546.2,
    x2: 698.86,
    y2: 546.2
  })), _line711 || (_line711 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 717.88,
    y1: 533.6,
    x2: 698.86,
    y2: 533.6
  })), _line712 || (_line712 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 717.88,
    y1: 533.6,
    x2: 698.86,
    y2: 533.6
  })), _line713 || (_line713 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 727.14,
    y1: 536.12,
    x2: 727.14,
    y2: 539.65
  })), _line714 || (_line714 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 717.88,
    y1: 536.12,
    x2: 727.14,
    y2: 536.12
  })), _line715 || (_line715 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 717.88,
    y1: 539.65,
    x2: 727.14,
    y2: 539.65
  })), _line716 || (_line716 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 760.25,
    y1: 549.83,
    x2: 765.39,
    y2: 549.83
  })), _line717 || (_line717 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 750.27,
    y1: 536.42,
    x2: 773.92,
    y2: 536.42
  })), _line718 || (_line718 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 750.27,
    y1: 539.14,
    x2: 773.92,
    y2: 539.14
  })), _line719 || (_line719 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 762.31,
    y1: 529.06,
    x2: 755.11,
    y2: 529.06
  })), _line720 || (_line720 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 762.31,
    y1: 533.6,
    x2: 762.31,
    y2: 529.06
  })), _line721 || (_line721 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 755.11,
    y1: 533.6,
    x2: 755.11,
    y2: 529.06
  })), _line722 || (_line722 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 771.56,
    y1: 530.58,
    x2: 771.56,
    y2: 533.9
  })), _line723 || (_line723 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 771.56,
    y1: 533.9,
    x2: 763.85,
    y2: 533.9
  })), _line724 || (_line724 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 771.56,
    y1: 530.58,
    x2: 763.85,
    y2: 530.58
  })), _line725 || (_line725 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 769.3,
    y1: 549.83,
    x2: 755.11,
    y2: 549.83
  })), _line726 || (_line726 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 769.3,
    y1: 533.6,
    x2: 769.3,
    y2: 549.83
  })), _line727 || (_line727 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 755.11,
    y1: 533.6,
    x2: 755.11,
    y2: 549.83
  })), _line728 || (_line728 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 755.11,
    y1: 533.6,
    x2: 769.3,
    y2: 533.6
  })), _line729 || (_line729 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 763.85,
    y1: 530.58,
    x2: 763.85,
    y2: 533.9
  })), _line730 || (_line730 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 794.69,
    y1: 536.12,
    x2: 795.41,
    y2: 536.12
  })), _line731 || (_line731 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 794.69,
    y1: 539.65,
    x2: 795.41,
    y2: 539.65
  })), _line732 || (_line732 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 794.69,
    y1: 536.12,
    x2: 794.69,
    y2: 539.65
  })), _line733 || (_line733 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 774.95,
    y1: 536.12,
    x2: 794.69,
    y2: 536.12
  })), _line734 || (_line734 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 774.95,
    y1: 539.65,
    x2: 794.69,
    y2: 539.65
  })), _line735 || (_line735 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 794.69,
    y1: 539.65,
    x2: 794.69,
    y2: 536.12
  })), _line736 || (_line736 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 773.92,
    y1: 536.12,
    x2: 774.95,
    y2: 536.12
  })), _line737 || (_line737 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 773.92,
    y1: 539.65,
    x2: 774.95,
    y2: 539.65
  })), _line738 || (_line738 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 773.92,
    y1: 536.12,
    x2: 773.92,
    y2: 539.65
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamiMapsGl01Tl04);
export default __webpack_public_path__ + "static/media/NAMI Maps_GL01 TL04.688ae5f533fdd99bc4a910ed5058e7de.svg";
export { ForwardRef as ReactComponent };